<template>
  <!-- registration card -->
  <div class="w-100">
    <div class="registration-card-container" v-if="localRegistration.type === 'main'">
      <div class="info-container">
        <div class="info-description">
          <div class="img-container">
            <el-avatar>
              <img :src="getRegoLogo(localRegistration)" />
            </el-avatar>
          </div>
          <div class="title">
            {{ localRegistration.name }}
          </div>
          <div class="orgtree-level">
            {{ localRegistration.orgtree[localRegistration.entityType].name }}
          </div>
          <div
            v-if="!get(localRegistration, 'isClubMembership', false) && !get(localRegistration, 'useDuration', false)"
            class="duration">
            {{ formatStartDate(dateFormatter(get(localRegistration, 'startDate')), get(localRegistration, 'endDate')) }}
            {{ formatEndDate(get(localRegistration, 'endDate')) }}
          </div>
          <div v-else-if="get(localRegistration, 'useDuration', false)" class="duration">
            {{ formatDuration(localRegistration) }}
          </div>
          <div v-else-if="get(localRegistration, 'isClubMembership', false)" class="duration">
            {{ formatExpiry(get(localRegistration, 'expiry')) }}
          </div>
          <!-- <div v-if="localRegistration.isRegoOpen && !isExpired(localRegistration.product[0].regoEndDate)" class="register-button">
              <el-button type="primary" class="register-button" @click="register(rego)">Register</el-button>
            </div>
            <div v-else class="">
              <el-button type="primary" class=" closed-register" disabled>Registration is closed</el-button>
            </div> -->
          <div class="register-button" v-if="localRegistration.isRegoOpen">
            <el-button type="primary" @click="handleEventRegsiterClicked">
              Register
              {{ localRegistration.product.length > 1 ? ' +' : '' }}
            </el-button>
          </div>
          <div class="register-button" v-else>
            <el-button type="primary" class="closed-register" disabled>Registration is closed
            </el-button>
          </div>
        </div>
      </div>
      <div class="triangle-indicator" v-if="localRegistration.showIndicators">
      </div>
    </div>

    <!-- desktop and landscape tablet orientation -->
    <div :class="{ 'products-container': true }" v-if="localRegistration.type === 'addon' && windowWidth > 1024">
      <div class="label-headers">
        <!-- <div class="label-header" :style="{ 'grid-column-start': 1 }">Member Type</div>
      <div class="label-header" :style="{ 'grid-column-start': 2 }">Gender</div> -->
        <!-- last section is for event description -->
        <!-- <div class="description pb-1" :style="{ 'grid-column-start': 1 }" v-html="get(localRegistration, 'description', '')"></div> -->
        <!-- <div class="description-expand" >
          <div ref="description" class="description" :class="{ expanded: isDescriptionExpanded, 'no-gradient': !showExpandIcon, }" v-html="get(localRegistration, 'description', '')">
          </div>
          <span v-if="showExpandIcon" class="expand-icon" @click="toggleDescription">
            <span v-if="isDescriptionExpanded">
              <span class=" mr-05">Show Less</span>
              <i  class="el-icon-arrow-up"></i>
            </span>
            <span v-else>
              <span class=" mr-05">Show More</span>
              <i  class="el-icon-arrow-down"></i>
            </span>
          </span>
        </div> -->
        <div class="description-expand">
          <div ref="desktopDescription" class="description" :class="{ expanded: true, 'no-gradient': true, }"
            v-html="get(localRegistration, 'description', '')">
          </div>
        </div>

      </div>
      <el-collapse v-model="activeTabNames">
        <el-collapse-item v-for="(group, index) in groupedByRegistrationType" :name="group.key" :key="index">
          <template slot="title">
            <div class="overview-grid">
              <span>
                <p class="tag dark-color member-type header m-0">
                  {{ group.header }}
                </p>
              </span>
            </div>
          </template>
          <div class="product-container">
            <div class="product-container-main header">
              <div class="product-description">
                <p>
                  {{ group.products.length && group.products[0].type !== 'team' ? 'Member Type' : '' }}
                </p>
                <p>
                  {{ group.products.length && group.products[0].type !== 'team' ? 'Gender' : '' }}
                </p>
                <p>Age Range</p>
                <p>Product</p>
              </div>
              <p class="text-center">Price</p>
              <p class="text-center">Action</p>
            </div>
          </div>
          <div>
            <div v-for="p in group.products" :key="p._id">
              <div class="product-container">
                <div class="product-container-main">
                  <div class="product-description">
                    <!-- <div class="product-memberType">
                <el-tag class="tag dark-color memberType" >
                  {{ p.memberType? p.memberType : p.type | capitalize }}
                </el-tag>
              </div>
              <div class="product-gender ">
                <el-tag class="tag dark-color gender" v-if="p.gender">
                  {{ p.gender? p.gender : ''  | capitalize }}
                </el-tag>
              </div> -->

                    <div class="d-flex gap-1 align-items-center ">
                      <span>
                        <el-tag class="" type="info" v-if="p.memberType">
                          {{ getNationalMemberTypeName(p.memberType) }}
                        </el-tag>
                      </span>
                    </div>
                    <div class="d-flex gap-1 align-items-center ">
                      <span v-if="p.gender && p.gender !== 'undefined'">
                        <el-tag class="" type="info">
                          {{ p.gender ? p.gender : '' | capitalize }}
                        </el-tag>
                      </span>
                    </div>
                    <div class="d-flex gap-1 align-items-center">
                      <i class="el-icon-s-data"></i>
                      <span class="age-range-text">
                        {{ p.ageFrom }} - {{ p.ageTo }}
                      </span>
                    </div>
                    <div class="d-flex align-items-center gap-2" v-if="p.name">
                      <p class="product-displayName">{{ p.name }} </p>
                      <!-- Product-level Upgrade Badge -->
                      <div v-if="checkProductUpgradeEligible && checkProductUpgradeEligible(localRegistration._id, p._id)" class="product-upgrade-container">
                        <el-tag type="success" class="product-upgrade-badge" size="mini" @click="handleProductUpgradeClick(p)">
                          <i class="el-icon-top-right"></i> Upgrade
                        </el-tag>
                        <el-tooltip effect="light" placement="top">
                          <div class="tooltip-content" slot="content">
                            This product can be upgraded<br/>
                            from your existing membership.<br/>
                            <span style="color: #67C23A; font-weight: bold;">Click to upgrade!</span>
                          </div>
                          <i class="el-icon-info product-upgrade-info-icon"></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                <!-- <div class="product-tags" v-if="product.tags && product.tags.length > 0" >
              <span>
                {{ tagsFormatted(product.tags) }}
              </span>
            </div> -->
                  <!-- <div v-else class="product-tags">
              <span>
                No Tags
              </span>
            </div> -->
                  <div class="product-price">
                    {{ priceFormatted(p.price) }}
                  </div>
                  <div class="product-register">
                    <!-- <el-dropdown v-if="p.type === 'indv-to-team'" size="medium"
                    @command="handleTeamSelected" trigger="click">
                    <el-button type="primary" size="medium"

                      :disabled="checkFullSlot(p) || !p.isActive || !p.isRegoOpen || !isEligible(p)">
                      {{getButtonLabel(p)}}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
            <div v-if="filteredTeams(p).length">
              <div class="grid grid-cols-2 gap-20 px-10">
                <div><strong>Team</strong></div>
                <div><strong>Contact</strong></div>
              </div>
              <el-dropdown-item v-for="team in filteredTeams(p)" :key="team._id" :disabled="team.isFull || checkIndvTeamRegistered(p,team._id)"
                :command="{teamId:team._id, productId: p._id}">
                <div class="grid grid-cols-2 gap-20">
                  <div>{{ team.name }} {{ team.isFull ? '(Full)' : '' }}</div>
                  <div>{{ get(team, 'meta[0].contact.name', 'Not Available') }}</div>
                </div>
              </el-dropdown-item>
            </div>
            <div v-else>
              <el-dropdown-item disabled>No Teams Available</el-dropdown-item>
                                  </div>
                      </el-dropdown-menu>

                  </el-dropdown> -->
                    <el-popover v-if="p.type === 'indv-to-team'" placement="left" width="480" trigger="click">
                      <div class="mb-10">
                        <el-input prefix-icon="el-icon-search" clearable v-model="teamKeyword"
                          placeholder="Search by team or contact name" @input="debounceSearch">
                        </el-input>
                      </div>
                      <el-table :data="filteredTeams(p)" max-height="400" @row-click="handleTeamSelected($event, p._id)"
                        :row-class-name="getRowClassName(p)">
                        <el-table-column width="80" property="name" label="ID">
                          <template slot-scope="scope">
                            <span>{{ scope.row._id }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column width="220" property="date" label="Team Name">
                          <template slot-scope="scope">
                            <span class="break-word">{{ getDisplayName(scope.row, p) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column width="150" label="Contact Name">
                          <template slot-scope="scope">
                            <div style="display: flex; align-items: flex-start;">
                              <span class="break-word">{{ scope.row.meta[0].contact.name }}</span>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                      <!-- <el-button  v-if="p.type === 'indv-to-team'">Click to activate</el-button> -->
                      <el-button slot="reference" type="primary" size="medium"
                        :disabled="(checkFullSlot(p) && !(p.type === 'indv-to-team' && checkIsWaitlistOpen(p))) || !p.isActive || !p.isRegoOpen || !isEligible(p) || checkRegistered(p._id)">
                        {{ getButtonLabel(p) }}

                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                    </el-popover>

                    <!-- else if type = 'entity' -->
                    <el-dropdown v-else-if="p.type === 'entity'" size="medium" @command="handleEntitySelected"
                      trigger="click">
                      <el-button type="primary" size="medium"
                        :disabled="!p.isActive || !p.isRegoOpen || checkFullSlot(p)">
                        Entity
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="entity in p.entityTypeList" :key="entity.value"
                          :command="{ entityId: entity.value, productId: p._id, entityType: entity.type }">
                          {{ entity.name }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <el-button v-else-if="checkIsWaitlistOpen(p)" type="primary" size="medium"
                      @click="joinWaitlist(p._id)">
                      Join Waitlist
                    </el-button>
                    <!-- Family membership popover -->
                    <el-popover v-else-if="p.familyMS && p.familyMS.length" placement="left" width="600" trigger="click">
                      <div class="family-ms-popover">
                        <h3 class="mb-10">{{ get(localRegistration, 'name') }}</h3>
                        <div class="family-ms-content">
                          <el-table style="width: 100%" :data="familyMSList" size="mini">
                            <el-table-column label="Member Type" min-width="120">
                              <template v-slot="scope">
                                <el-tag v-if="scope.row.memberType" type="info" size="mini">
                                  {{ scope.row.memberType | capitalize }}
                                </el-tag>
                              </template>
                            </el-table-column>
                            <el-table-column label="Gender" min-width="100">
                              <template v-slot="scope">
                                <el-tag v-if="scope.row.gender" type="info" size="mini">
                                  {{ scope.row.gender | capitalize }}
                                </el-tag>
                              </template>
                            </el-table-column>
                            <el-table-column label="Age" width="80">
                              <template v-slot="scope">
                                <span>{{ scope.row.ageFrom }}-{{ scope.row.ageTo }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column min-width="200" label="Member">
                              <template v-slot="scope">
                                <el-select v-model="scope.row.memberId" placeholder="Select" size="mini"
                                  :disabled="disabledMemberSelect">
                                  <el-option v-for="e in scope.row.availableMembers"
                                    :label="`${e.profile.firstName} ${e.profile.lastName}`" :key="e._id" :value="e._id"
                                    :disabled="familyMSList.some(row => row !== scope.row && row.memberId === e._id)" />
                                </el-select>
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                        <div class="family-ms-actions mt-10">
                          <el-button size="small" @click="cancelFamilyRego">Cancel</el-button>
                          <el-button type="primary" size="small" :disabled="!isAllMembersSelected"
                            @click="initRegoFamily(familyMSList)">
                            Register
                          </el-button>
                        </div>
                      </div>
                      <el-button slot="reference" type="primary" size="medium"
                        :disabled="(checkRegistered(p._id) && !checkPayAfter(p._id) && !isRenewable(p) && !canRegisterAgain(p)) || checkFullSlot(p) || !isEligible(p) || !p.isActive || (!p.isRegoOpen && !p.isWaitlistOpen)"
                        @click="prepareFamilyRegistration(p)">
                        {{ getButtonLabel(p) }}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                    </el-popover>
                    <!-- Regular register button -->
                    <el-button v-else type="primary" size="medium"
                      :disabled="(checkRegistered(p._id) && !checkPayAfter(p._id) && !isRenewable(p) && !canRegisterAgain(p)) || checkFullSlot(p) || !isEligible(p) || !p.isActive || (!p.isRegoOpen && !p.isWaitlistOpen)"
                      @click="register(p._id, $event)">
                      {{ getButtonLabel(p) }}
                      <fa-icon v-if="getButtonLabel(p) == 'Required'" style="color:#E6A23C"
                        :icon="['fal', 'circle-exclamation']" />
                    </el-button>
                    <!-- <el-button class="secondary-type ml-10"  size="medium" @click="` ; `(p._id)">
                More Details
                {{ p.showMoreDetails? ' -' : ' +' }}
              </el-button> -->
                  </div>
                </div>
                <div v-show="true || p.showMoreDetails" :key="key" class="px-10 mt-10">
                  <div class="" v-if="p.tags && p.tags.length > 0">
                    <span v-for="tag in p.tags" :key="tag._id">
                      <span class="ml-05 product-tag" @click="searchByTag(tag)">
                        #{{ tag.name }}

                      </span>
                    </span>
                  </div>
                  <!-- <div v-else class="product-tag">
                  <span class="ml-05 tag">
                    #NoTags
                  </span>
                </div> -->
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <!-- mobile and portrait tablet orientation -->
    <div :class="{ 'products-container-mobile': true, 'pb-05': true }"
      v-if="localRegistration.type === 'addon' && windowWidth <= 1024">
      <div class="label-headers">
        <!-- <div class="label-header" :style="{ 'grid-column-start': 1 }">Member Type</div>
      <div class="label-header" :style="{ 'grid-column-start': 2 }">Gender</div> -->
        <!-- last section is for event description -->
        <div class="description-expand">
          <div ref="mobileDescription" class="description"
            :class="{ expanded: isDescriptionExpanded, 'no-gradient': !showExpandIcon }"
            v-html="get(localRegistration, 'description', '')">
          </div>
          <span v-if="showExpandIcon" class="expand-icon mb-10" @click="toggleDescription">
            <span v-if="isDescriptionExpanded">
              <span class="sr-only mr-05">Show Less</span>
              <i class="el-icon-arrow-up"></i>
            </span>
            <span v-else>
              <span class="sr-only mr-05">Show More</span>
              <i class="el-icon-arrow-down"></i>
            </span>
          </span>
        </div>

      </div>

      <!-- Custom Expandable Sections with Sticky Headers -->
      <div class="custom-collapse-container">
        <div v-for="(group) in groupedByRegistrationType" :key="group.key" class="custom-collapse-section"
          :ref="`collapse-section-${group.key}`">

          <!-- Section Header (Always visible on mobile) -->
          <div v-if="windowWidth > 1024" :class="{
            'custom-section-header': true,
            'is-expanded': activeTabNames.includes(group.key),
            'sticky-section-header': true
          }" :ref="`section-header-${group.key}`" @click="toggleSection(group.key)">
            <div class="overview-grid" :data-product-type="group.header">
              <span>
                <p class="tag dark-color member-type header">
                  {{ group.header }}
                </p>
              </span>
              <i :class="activeTabNames.includes(group.key) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
          </div>

          <!-- Mobile Section Header (Sticky, Non-collapsible) -->
          <div v-else class="mobile-section-header sticky-mobile-header" :ref="`mobile-section-header-${group.key}`">
            <h3 class="section-title">{{ group.header }}</h3>
          </div>

          <!-- Content (Always expanded on mobile) -->
          <div :class="{
            'custom-section-content': windowWidth > 1024,
            'is-expanded': windowWidth <= 1024 || activeTabNames.includes(group.key),
            'is-collapsed': windowWidth > 1024 && !activeTabNames.includes(group.key),
            'mobile-section-content': windowWidth <= 1024
          }">

            <!-- Desktop header for product details -->
            <div class="product-container" v-if="windowWidth > 1024">
              <div class="product-container-main header">
                <div class="product-description">
                  <p>
                    {{ group.products.length && group.products[0].type !== 'team' ? 'Member Type' : '' }}
                  </p>
                  <p>
                    {{ group.products.length && group.products[0].type !== 'team' ? 'Gender' : '' }}
                  </p>
                  <p>Age Range</p>
                  <p>Product</p>
                </div>
                <p>Price</p>
                <p>Action</p>
              </div>
            </div>
            <div v-if="windowWidth <= 1024">
              <div class="mobile-card-wrapper" v-for="p in group.products" :key="p._id">
                <div class="mobile-registration-card">
                  <!-- Card Header Section -->
                  <div class="mobile-card-header">
                    <div class="header-content">
                      <h3 class="card-title">{{ p.name || getDefaultProductName(p) }}</h3>
                      <div class="price-display">{{ priceFormatted(p.price) }}</div>
                    </div>
                  </div>

                  <!-- Essential Info Section -->
                  <div class="essential-info">
                    <div class="info-item" v-if="p.memberType">
                      <i class="el-icon-user"></i>
                      <span>{{ getNationalMemberTypeName(p.memberType) }}</span>
                    </div>
                    <div class="info-item">
                      <i class="el-icon-time"></i>
                      <span>Ages {{ p.ageFrom }}{{ p.ageTo !== 99 ? `-${p.ageTo}` : '+' }}</span>
                    </div>
                    <div class="info-item" v-if="p.gender && p.gender !== 'All'">
                      <i class="el-icon-user"></i>
                      <span>{{ p.gender }}</span>
                    </div>
                  </div>

                  <!-- Tags Section (if any) -->
                  <div v-if="p.tags && p.tags.length > 0" class="tags-section">
                    <span v-for="tag in p.tags.slice(0, 2)" :key="tag._id" class="product-tag" @click="searchByTag(tag)">
                      #{{ tag.name }}
                    </span>
                    <span v-if="p.tags.length > 2" class="more-tags">+{{ p.tags.length - 2 }}</span>
                  </div>

                  <!-- Primary Action Section OR Status Display -->
                  <div v-if="shouldShowActionButton(p)" class="card-actions">
                    <!-- Team Selection Popover for indv-to-team -->
                    <el-popover
                      v-if="p.type === 'indv-to-team' && filteredTeams(p).length"
                      placement="top"
                      width="90%"
                      trigger="click"
                      :visible-arrow="false"
                      :append-to-body="true"
                      popper-class="mobile-team-selection-popover">
                      <div class="team-selection-mobile">
                        <h4>Select a Team</h4>
                        <div class="team-search mb-10">
                          <el-input
                            prefix-icon="el-icon-search"
                            clearable
                            v-model="teamKeyword"
                            placeholder="Search by team or contact name"
                            @input="debounceSearch">
                          </el-input>
                        </div>
                        <div class="team-list">
                          <div
                            v-for="team in filteredTeams(p)"
                            :key="team._id"
                            :class="{
                              'team-row-card': true,
                              'team-row-disabled': team.isFull || checkIndvTeamRegistered(p,team._id)
                            }">
                            <!-- Team Info Section -->
                            <div class="team-info">
                              <div class="team-name">
                                {{ team.name }}
                                <span v-if="team.isFull" class="status-text"> (Full)</span>
                                <span v-else-if="checkIndvTeamRegistered(p,team._id)" class="status-text"> (Registered)</span>
                              </div>
                              <div class="team-contact" v-if="team.meta && team.meta[0] && team.meta[0].contact">
                                Contact: {{ team.meta[0].contact.name }}
                              </div>
                            </div>

                            <!-- Register Button Section -->
                            <div class="team-action">
                              <el-button
                                size="mini"
                                type="primary"
                                :disabled="team.isFull || checkIndvTeamRegistered(p,team._id)"
                                @click="handleTeamSelected(team, p._id)"
                                class="register-btn">
                                {{ team.isFull ? 'Full' : checkIndvTeamRegistered(p,team._id) ? 'Registered' : 'Join' }}
                              </el-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <el-button
                        slot="reference"
                        type="primary"
                        size="large"
                        class="action-btn primary-action">
                        <i class="el-icon-user-solid"></i>
                        Join Team
                        <i class="el-icon-arrow-down ml-1"></i>
                      </el-button>
                    </el-popover>

                    <!-- No teams available for indv-to-team -->
                    <el-button
                      v-else-if="p.type === 'indv-to-team' && !filteredTeams(p).length"
                      type="primary"
                      size="large"
                      class="action-btn"
                      disabled>
                      <i class="el-icon-user-solid"></i>
                      No Teams Available
                    </el-button>

                    <!-- Family membership popover for mobile -->
                    <el-popover
                      v-else-if="p.familyMS && p.familyMS.length"
                      placement="top"
                      width="90%"
                      trigger="click"
                      :visible-arrow="false"
                      :append-to-body="true"
                      popper-class="mobile-family-popover">
                      <div class="family-ms-popover mobile-family-ms-popover">
                        <h3 class="mb-10">{{ get(localRegistration, 'name') }}</h3>
                        <div class="family-ms-content">
                          <div class="mobile-family-ms">
                            <div v-for="(item, index) in familyMSList" :key="index" class="mobile-family-ms-item">
                              <div class="mobile-family-ms-info">
                                <div class="mobile-family-ms-field">
                                  <span class="mobile-label"><i class="el-icon-user"></i> Type:</span>
                                  <el-tag v-if="item.memberType" class="mobile-tag" type="info" size="mini">{{ item.memberType | capitalize }}</el-tag>
                                </div>
                                <div class="mobile-family-ms-field">
                                  <span class="mobile-label"><i class="el-icon-male"></i> Gender:</span>
                                  <el-tag v-if="item.gender" class="mobile-tag" type="info" size="mini">{{ item.gender | capitalize }}</el-tag>
                                </div>
                                <div class="mobile-family-ms-field">
                                  <span class="mobile-label"><i class="el-icon-date"></i> Age:</span>
                                  <span class="mobile-age-range">{{ item.ageFrom }}-{{ item.ageTo }}</span>
                                </div>
                                <div class="mobile-family-ms-field">
                                  <el-select v-model="item.memberId" placeholder="Select Member" size="mini" class="mobile-member-select">
                                    <el-option v-for="e in item.availableMembers"
                                      :label="`${e.profile.firstName} ${e.profile.lastName}`" :key="e._id" :value="e._id"
                                      :disabled="familyMSList.some(row => row !== item && row.memberId === e._id)" />
                                  </el-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="family-ms-actions mt-10">
                          <el-button size="small" @click="cancelFamilyRego">Cancel</el-button>
                          <el-button type="primary" size="small" :disabled="!isAllMembersSelected"
                            @click="initRegoFamily(familyMSList)">
                            Register
                          </el-button>
                        </div>
                      </div>
                      <el-button
                        slot="reference"
                        type="primary"
                        size="large"
                        class="action-btn primary-action"
                        @click="prepareFamilyRegistration(p)">
                        <i class="el-icon-s-custom"></i>
                        Family Register
                        <i class="el-icon-arrow-down ml-1"></i>
                      </el-button>
                    </el-popover>

                    <!-- Regular register button -->
                    <el-button
                      v-else-if="canRegisterDirectly(p)"
                      type="primary"
                      size="large"
                      class="action-btn primary-action"
                      @click="register(p._id, $event)">
                      <i class="el-icon-plus"></i>
                      Register Now
                    </el-button>

                    <!-- Other status buttons -->
                    <el-button
                      v-else
                      :type="getButtonType(p)"
                      size="large"
                      class="action-btn"
                      :class="getButtonClass(p)"
                      :disabled="isButtonDisabled(p)"
                      @click="handleStatusAction(p)">
                      <i :class="getActionIcon(p)"></i>
                      <span>
                        {{ getButtonLabel(p) }}
                        <span v-if="getButtonLabel(p) === 'Required'" class="button-subtitle">
                          Get membership first
                        </span>
                      </span>
                    </el-button>
                  </div>

                  <!-- Status Display for Non-Actionable States -->
                  <div v-else class="status-display-section">
                    <div class="status-alert" :class="getStatusAlertClass(p)">
                      <i :class="getStatusIcon(p)"></i>
                      <div class="status-info">
                        <span class="status-title">{{ getButtonLabel(p) }}</span>
                        <span class="status-desc">{{ getStatusDescription(p) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="windowWidth <= 1024" style="display: none;">
              <div class="p-05" v-for="p in group.products" :key="p._id">
                <div class="clean-product-card">
                  <!-- OLD MOBILE CARD CODE - HIDDEN -->
                  <div class="card-action">
                    <!-- Team selection for indv-to-team -->
                    <el-popover
                      v-if="p.type === 'indv-to-team' && filteredTeams(p).length"
                      placement="top"
                      width="500"
                      trigger="click"
                      :visible-arrow="false"
                      :append-to-body="true"
                      popper-class="team-selection-popover">
                      <div class="team-selection-mobile">
                        <h4>Select a Team</h4>
                        <div class="team-search mb-10">
                          <el-input
                            prefix-icon="el-icon-search"
                            clearable
                            v-model="teamKeyword"
                            placeholder="Search by team or contact name"
                            @input="debounceSearch">
                          </el-input>
                        </div>
                        <div class="team-list">
                          <div
                            v-for="team in filteredTeams(p)"
                            :key="team._id"
                            :class="{
                              'team-row-card': true,
                              'team-row-disabled': team.isFull || checkIndvTeamRegistered(p,team._id)
                            }">
                            <!-- Team Info Section -->
                            <div class="team-info">
                              <div class="team-name">
                                {{ team.name }}
                                <span v-if="team.isFull" class="status-text"> (Full)</span>
                                <span v-else-if="checkIndvTeamRegistered(p,team._id)" class="status-text"> (Registered)</span>
                              </div>
                              <div class="team-contact" v-if="team.meta && team.meta[0] && team.meta[0].contact">
                                Contact: {{ team.meta[0].contact.name }}
                              </div>
                            </div>

                            <!-- Register Button Section -->
                            <div class="team-action">
                              <el-button
                                size="mini"
                                type="primary"
                                :disabled="team.isFull || checkIndvTeamRegistered(p,team._id)"
                                @click="handleTeamSelected(team, p._id)"
                                class="register-btn">
                                {{ team.isFull ? 'Full' : checkIndvTeamRegistered(p,team._id) ? 'Registered' : 'Join' }}
                              </el-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <el-button
                        slot="reference"
                        :type="getButtonType(p)"
                        size="medium"
                        class="action-button"
                        :disabled="checkFullSlot(p) || !p.isActive || !p.isRegoOpen || !isEligible(p) || checkRegistered(p._id)">
                        {{getActionButtonLabel(p)}}
                        <i class="el-icon-arrow-down ml-1"></i>
                      </el-button>
                    </el-popover>

                    <!-- Regular action button for non-team products -->
                    <el-button
                      v-else
                      :type="getButtonType(p)"
                      size="medium"
                      class="action-button"
                      :disabled="isButtonDisabled(p)"
                      @click="register(p._id, $event)">
                      {{ getActionButtonLabel(p) }}
                      <i v-if="shouldShowStatusIcon(p)" :class="getStatusIcon(p)" class="ml-1"></i>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-popover
      ref="passwordPopover"
      width="400"
      trigger="manual"
      v-model="showAuthProduct"
      placement="top"
      popper-class="password-required-popover"
      :visible-arrow="true">
      <div class="password-popover-content">
        <div class="popover-header">
          <h4>Password Required</h4>
        </div>

        <div class="popover-body">
          <p class="password-description">
            Password required to enter this event, do you want to request a password?
          </p>

          <div class="action-section">
            <el-button
              @click="requestAccess"
              size="small"
              type="text"
              class="request-btn">
              Request Password
            </el-button>
          </div>

          <el-form
            :model="product"
            :rules="passwordRules"
            ref="productPassForm"
            class="password-form">
            <el-form-item prop="password" label="Password">
              <el-input
                class="custom-input-password"
                type="password"
                v-model="product.password"
                placeholder="Enter password"
                size="small" />
            </el-form-item>

            <div v-if="errorMessage" class="error-message">
              <el-alert
                show-icon
                type="error"
                :title="errorMessage"
                :closable="false"
                size="small" />
            </div>
          </el-form>
        </div>

        <div class="popover-footer">
          <el-button
            @click="closePasswordPopover()"
            size="small">
            Cancel
          </el-button>
          <el-button
            class="confirm-button"
            @click="authProduct"
            type="primary"
            size="small">
            Submit
          </el-button>
        </div>
      </div>

      <span slot="reference" id="password-popover-trigger" style="display: none;"></span>
    </el-popover>
    <el-dialog
      v-if="showTeamSelect"
      title="Select Team"
      :visible.sync="showTeamSelect"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      width="700px"
      :lock-scroll="true"
      custom-class="team-selection-dialog"
      :before-close="handleTeamDialogClose">
      <div class="team-dialog-content">
        <div class="dialog-description">
          <p>Please select or search for your team from the list to register</p>
        </div>

        <div class="search-section">
          <el-input
            class="search-input"
            placeholder="Search by team name or ID"
            v-model="teamKeyword"
            @keyup.enter.native="searchTeam"
            size="medium">
            <el-button slot="suffix" icon="el-icon-search" @click="searchTeam">
            </el-button>
          </el-input>
        </div>

        <div class="help-text">
          <p>Can't find your team on this list?<br>Try searching for it.</p>
        </div>
        <div class="teams-section">
          <div class="teams-list">
            <div
              v-for="team in allTeams"
              :key="team._id"
              class="team-card"
              :class="{ 'my-team': team.isMyTeam }">

              <div class="team-main-info">
                <div class="team-header">
                  <div class="team-name">
                    {{ team.name }}
                  </div>
                  <div class="team-action">
                    <el-button
                      class="register-btn"
                      :type="checkTeamRegistered(team) ? 'info' : 'primary'"
                      size="small"
                      @click="initRegisterTeam(team)"
                      :disabled="checkTeamRegistered(team)">
                      {{ checkTeamRegistered(team) ? 'Registered' : 'Register' }}
                    </el-button>
                  </div>
                </div>

                <div class="team-details">
                  <div class="team-org">
                    <i class="el-icon-office-building"></i>
                    {{ getFirstOrgtree(team) }}
                  </div>
                  <div class="team-meta">
                    <span class="created-date">
                      <i class="el-icon-date"></i>
                      {{ moment(team.createdAt).format('DD/MM/YYYY') }}
                    </span>
                    <span class="created-by">
                      <i class="el-icon-user"></i>
                      {{ get(team, 'createdBy[0].profile.firstName', 'N/A') }}
                      {{ get(team, 'createdBy[0].profile.lastName', '') }}
                      <el-tag v-if="team.isMyTeam" class="my-team-badge" size="mini" type="info">
                        <i class="el-icon-s-home"></i> Your Team
                      </el-tag>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="allTeams.length === 0" class="empty-state">
              <i class="el-icon-info"></i>
              <p>No teams found. Try adjusting your search.</p>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTeamSelect = false" size="medium">Cancel</el-button>
        <el-button class="register-button" type="primary" size="medium" @click="createNewTeam()">Create new team</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="showEntitySelect" title="Select Entity" :visible.sync="showEntitySelect">
      <div class="break-word">Please select or search for your entity from the list to register </div>
      <div class="search-bar-team">
        <el-input class="input-field" placeholder="Search by entity name or ID" v-model="teamKeyword"
          @keyup.enter.native="searchEntity">
          <!-- <div slot="prefix" class="d-flex align-items-center mr-20" style="cursor:pointer; height:100%; padding: 0.35rem;" @click="search">
                  <i class="el-icon-search"></i>
                </div> -->
          <el-button slot="suffix" icon="el-icon-search" size="small" @click="searchEntity">
          </el-button>
        </el-input>
      </div>
      <div class="add-new-team">
        <!-- add a line say "Can't find your team? Add a new team" -->
        <div class="mt-10">
          Can't find your entity on this list? Try searching for it. Or
          <span>
            <el-button class="register-button" type="text" size="medium" @click="createNewEntity()">
              Create a new entity</el-button>
          </span>
        </div>

      </div>
      <!-- take form selectedRego.products[0].membershipProductsRequired -->
      <el-table class="item-table " :border="true" highlight-current-row stripe max-height="500" :data="allEntities">
        <el-table-column type="expand">
          <template slot-scope="props">
            <!-- display in legend style -->
            <fieldset>
              <legend>Entities Details</legend>
              <div class="break-word">
                {{ getOrgtree(props.row) }}
              </div>
              <div>
                Created At: {{ moment(props.row.createdAt).format('DD/MM/YYYY') }}
              </div>
              <div>
                Created By: {{ get(props, 'row.createdBy[0].profile.firstName', 'N/A') }}
                {{ get(props, 'row.createdBy[0].profile.lastName') }}
              </div>
            </fieldset>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" min-width="300">
        </el-table-column>
        <!-- column to indicate your team -->
        <el-table-column prop="isMyTeam" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.isMyTeam">
              Your Entity
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="Operation" width="110">
          <template slot-scope="scope">
            <el-button class="register-button" type="select" size="mini"
              @click="registerEntity(scope.row)">Register</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTeamSelect = false">Cancel</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="showTeamSelectIndvToTeam"
      title="Select Team"
      :visible.sync="showTeamSelectIndvToTeam"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      width="60%"
      :lock-scroll="true"
      :before-close="handleIndvTeamDialogClose">
      <!-- take form selectedRego.products[0].membershipProductsRequired -->
      <!-- <el-table class="item-table "  :border="true" highlight-current-row stripe max-height="500" :data="filteredTeams(tempProduct)" >
          <el-table-column
            prop="name"
            label="Name"
            min-width="300">
          </el-table-column>
          <el-table-column fixed="right" label="Operation" width="110" >
            <template slot-scope="scope">
              <el-button class="register-button" type="select"  size="mini" @click="handleTeamSelectedMethod(scope.row)">Select</el-button>
            </template>
          </el-table-column>
        </el-table> -->
      <!-- change from table above to  div contains el-card -->
      <el-input key="mobile-team-search" prefix-icon="el-icon-search" clearable v-model="teamKeyword"
        placeholder="Search by team or contact name" @input="debounceSearch">
      </el-input>
      <div class="team-selector" v-for="(team, index) in filteredTeams(tempProduct)" :key="`${team._id}-${index}`">
        <el-card class="mb-10">
          <div class="d-flex gap-1 justify-content-between align-items-center p-10 ">
            <div class="team-selector-container">
              <div class="team-selector-name break-word">
                {{ `${getDisplayName(team, tempProduct)} - ${get(team, 'meta[0].contact.name', 'N/A')}` }}
              </div>
            </div>
            <div class="team-selector-button">
              <el-button class="register-button" type="select" size="mini"
                @click="handleTeamSelectedMethod(team, tempProduct)">Select</el-button>
            </div>
          </div>
        </el-card>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTeamSelectIndvToTeam = false">Cancel</el-button>
      </span>

    </el-dialog>
    <el-dialog :append-to-body="true" :modal-append-to-body="true" :fullscreen="false" :modal="true"
      :title="`${get(localRegistration, 'name')}`" :visible.sync="familyMSDialog" :width="isMobile ? '95%' : '75%'"
      custom-class="family-ms-dialog nested-dialog">

      <div class="d-flex flex-column w-100">
        <template v-if="isMobile">
          <div class="mobile-family-ms">
            <div v-for="(item, index) in familyMSList" :key="index" class="mobile-family-ms-item">
              <div class="mobile-family-ms-info">
                <div class="mobile-family-ms-field">
                  <span class="mobile-label"><i class="el-icon-user"></i> Member Type:</span>
                  <el-tag v-if="item.memberType" class="mobile-tag" type="info">{{ item.memberType | capitalize }}</el-tag>
                </div>
                <div class="mobile-family-ms-field">
                  <span class="mobile-label"><i class="el-icon-male"></i> Gender:</span>
                  <el-tag v-if="item.gender" class="mobile-tag" type="info">{{ item.gender | capitalize }}</el-tag>
                </div>
                <div class="mobile-family-ms-field">
                  <span class="mobile-label"><i class="el-icon-date"></i> Age Range:</span>
                  <span class="mobile-age-range">{{ item.ageFrom }} - {{ item.ageTo }}</span>
                </div>
                <div class="mobile-family-ms-field">
                  <!-- <span class="mobile-label"><i class="el-icon-s-custom"></i> Member:</span> -->
                  <el-select v-model="item.memberId" placeholder="Select Member" class="mobile-member-select">
                    <el-option v-for="e in item.availableMembers"
                      :label="`${e.profile.firstName} ${e.profile.lastName}`" :key="e._id" :value="e._id"
                      :disabled="familyMSList.some(row => row !== item && row.memberId === e._id)" />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="family-ms-content">
            <el-table :class="{ 'mobile-layout': isMobile }" style="width: 100%" :data="familyMSList">
              <el-table-column label="Member Type" min-width="120">
                <template v-slot="scope">
                  <el-tag v-if="scope.row.memberType" type="info">
                    {{ scope.row.memberType | capitalize }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="Gender" min-width="120">
                <template v-slot="scope">
                  <el-tag v-if="scope.row.gender" type="info">
                    {{ scope.row.gender | capitalize }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="Age Range" width="100">
                <template v-slot="scope">
                  <i class="el-icon-s-data"></i>
                  <span>
                    {{ scope.row.ageFrom }} - {{ scope.row.ageTo }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column min-width="260" label="Member">
                <template v-slot="scope">
                  <el-select v-model="scope.row.memberId" placeholder="Select" class="member-select"
                    :disabled="disabledMemberSelect">
                    <el-option v-for="e in scope.row.availableMembers"
                      :label="`${e.profile.firstName} ${e.profile.lastName}`" :key="e._id" :value="e._id"
                      :disabled="familyMSList.some(row => row !== scope.row && row.memberId === e._id)" />
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
        <div class="family-ms-actions">
          <el-button @click="cancelFamilyRego">Cancel</el-button>
          <el-button type="primary" :disabled="!isAllMembersSelected" class="color-highlight bd-0"
            @click="initRegoFamily(familyMSList)">
            Register
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="teamPasscodeDialog"
      title="Team Access Code Required"
      :visible.sync="teamPasscodeDialog"
      :width="isMobile ? '95%' : '500px'"
      :modal="true"
      :append-to-body="true"
      :modal-append-to-body="true"
      :lock-scroll="true"
      :close-on-click-modal="false"
      custom-class="team-passcode-dialog">
      <div class="passcode-content">
        <div class="team-info" v-if="selectedTeamForPasscode">
          <div class="team-avatar">
            <i class="el-icon-s-custom"></i>
          </div>
          <div class="team-details">
            <h3>{{ selectedTeamForPasscode.name }}</h3>
            <p>{{ get(selectedTeamForPasscode, 'meta[0].contact.name', 'Team Contact') }}</p>
          </div>
        </div>

        <div class="passcode-description">
          <p>This team requires an access code to join.</p>
          <p class="help-text">
            <i class="el-icon-info"></i>
            Contact your team administrator or check your team registration history for the access code.
          </p>
        </div>

        <div class="passcode-input-section">
          <label for="teamPasscode" class="passcode-label">Team Access Code</label>
          <el-input
            id="teamPasscode"
            v-model="teamPasscodeInput"
            placeholder="Enter 6-digit access code"
            :maxlength="6"
            class="passcode-input"
            @keyup.enter.native="validateTeamPasscode"
            @input="clearPasscodeError">
            <template slot="prepend">
              <i class="el-icon-lock"></i>
            </template>
          </el-input>

          <div v-if="passcodeError" class="error-message">
            <i class="el-icon-warning"></i>
            {{ passcodeError }}
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="teamPasscodeDialog = false" class="cancel-btn">
          Cancel
        </el-button>
        <el-button
          type="primary"
          @click="validateTeamPasscode"
          :disabled="!teamPasscodeInput || teamPasscodeInput.length !== 6"
          class="submit-btn">
          Join Team
        </el-button>
      </span>
    </el-dialog>
    <renew-payment v-if="showRenewPayment" @closeDialog="closeDialog" v-model="latestDialogValue"
      :rego="renewingProduct" />
    <el-dialog v-if="bulkRegoDialog" title="Bulk Registration" :visible.sync="bulkRegoDialog" :destroy-on-close="true"
      @close="handleCancelBulkRego">
      <div class="break-word mb-10">
        <el-alert type="info" show-icon :closable="false" title="Please select the members you want to register."
          description="Only eligible members will be displayed in the table." />
      </div>
      <!-- add more members button -->
      <div class="d-flex justify-content-end">
        <el-button @click="addMemberModal.visible = true" class="register-button mb-10" type="secondary" size="small">Add
          Members +</el-button>
      </div>
      <el-table :data="eligibleMembers" border @selection-change="handleSelectionChange" ref="bulkRegoTable"
        class="item-table " highlight-current-row stripe max-height="400">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="profile.firstName" label="Name" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.profile.firstName }} {{ scope.row.profile.lastName }}
          </template>
        </el-table-column>
        <el-table-column prop="profile.dob" label="Age" min-width="65">
          <template slot-scope="scope">
            {{ calculateAge(scope.row.profile.dob, get(localRegistration, 'meta.ageAsOfDate'), get(localRegistration,
            'meta.ageCalculationType')) }}
          </template>
        </el-table-column>
        <el-table-column prop="profile.gender" label="Gender" min-width="100">
          <template slot-scope="scope">
            <span class="break-word">{{ scope.row.profile.gender }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer d-flex gap-1">
        <el-button plain @click="handleCancelBulkRego">Cancel</el-button>
        <el-button type="primary" @click="submitBulkRegistration">Register</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="addMemberModal.page.title" :visible.sync="addMemberModal.visible" :close-on-click-modal="false"
      :destroy-on-close="true" :append-to-body="true">
      <new-member v-if="addMemberModal.page.name === 'new-member'" @updatePage="updatePage"
        @updateVisible="updateVisible" @selectMember="selectMember" @importedMembers="importedMembers"
        :product="selectedProduct" />
      <link-member v-if="addMemberModal.page.name === 'link-member'" @updatePage="updatePage"
        @updateVisible="updateVisible" :data="addMemberModal.data" @importedMembers="importedMembers"
        @selectMember="selectMember" />
    </el-dialog>

  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { datadogRum } from '@datadog/browser-rum';
import { calculateMemberAge } from '@/utils/helpers';
import RenewPayment from '@/views/app/components/RenewPayment.vue';
import NewMember from './NewMember';
import LinkMember from './LinkMember';

export default {
  components: { RenewPayment, NewMember, LinkMember },
  props: {
    registration: {
      type: Object,
      required: true,
    },
    privateProps: {
      type: Object,
      required: false,
      default: () => ({
        password: undefined,
        notFetching: false,
      }),
    },
    selectedMember: {
      type: Object,
      required: false,
    },
    members: {
      type: Array,
    },
    teamId: {
      type: String,
      required: false,
    },
    checkUpgradeEligible: {
      type: Function,
      required: false,
    },
    checkProductUpgradeEligible: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      dialogValue: {
        filtersVisible: false,
        entityType: undefined,
        registration: undefined,
        regoDetails: undefined,
        member: undefined,
      },
      renewingProduct: undefined,
      showRenewPayment: false,
      teamKeyword: '',
      teamPasscode: undefined,
      passcodeDialog: false,
      registeringTeam: undefined,
      teamPasscodeDialog: false,
      teamPasscodeInput: '',
      selectedTeamForPasscode: undefined,
      selectedProductForPasscode: undefined,
      passcodeError: '',
      get: _.get,
      familyMSDialog: false,
      disabledMemberSelect: false,
      familyMSList: [],
      selectedFamilyMS: undefined,
      activeTabNames: [],
      isAllExpanded: false,
      allTeams: [],
      allEntities: [],
      showTeamSelect: false,
      showEntitySelect: false,
      selectedEntity: undefined,
      defaultRegoLogo: process.env.VUE_APP_LOGO,
      localRegistration: {},
      selectedProduct: undefined,
      selectedProductArr: undefined,
      key: 0,
      windowWidth: window.innerWidth,
      // memberMembership: [],
      showAuthProduct: false,
      clickedButton: null,
      product: {
        password: undefined,
      },
      passwordRules: {
        password: [
          { required: true, message: 'Password is required', trigger: 'blur' }
        ]
      },
      errorMessage: undefined,
      showTeamSelectIndvToTeam: false,
      isDescriptionExpanded: false,
      showExpandIcon: false,
      bulkRegoDialog: false,
      selectedMembers: [],
      addMoreMembersDialog: false,
      addMemberModal: {
        visible: false,
        page: {
          name: 'new-member',
          title: 'Add Member'
        },
        data: undefined
      },
      selectedTeamForBulkRego: undefined,
      isMobile: window.innerWidth <= 767,
      originalMembersList: [], // Add this to store original members
      stickyObserver: null
    };
  },
  async mounted() {
    this.checkDescriptionHeight();
    window.addEventListener('resize', this.checkDescriptionHeight);
    this.updateStickyHeaderPositions();
    // const resMembers = await this.$http.get('/assemble/api/v1/account/portal/members-with-registrations');
    // this.members = resMembers.data.data;
    if (this.privateProps.password) this.product.password = this.privateProps.password;
    // this.memberMembership = this.$store.getters['user/getActiveMemberRegos'];
    this.localRegistration = _.cloneDeep(this.registration);

    this.localRegistration.product.forEach((product) => {
      // eslint-disable-next-line no-param-reassign
      product.showMoreDetails = false;
    });

    // Auto expand all products when the registration type is 'addon' or when entityId is provided
    if (this.privateProps.entityId || this.localRegistration.type === 'addon') {
      this.$nextTick(() => {
        this.expandAllProducts();
      });
    }

    // Ensure sticky positioning is set up properly, especially in drawer context
    setTimeout(() => {
      this.updateStickyHeaderPositions();
    }, 300);

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      this.setupStickyObserver();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('resize', this.checkDescriptionHeight);
    this.$root.$off('eventStickyHeaderChanged', this.updateStickyHeaderPositions);
    this.$root.$off('drawerExpandAllChanged', this.handleDrawerExpandAllChanged);
    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
    }
  },
  computed: {
    latestDialogValue() {
      return this.dialogValue;
    },
    eligibleMembers() {
      return this.members.filter((member) => this.isEligibleForBulkRego(member));
    },
    isAllMembersSelected() {
      return this.familyMSList.every((row) => row.memberId);
    },
    memberMembership() {
      return this.$store.getters['user/getActiveMemberRegos'];
    },
    groupedByTypeAndGender() {
      const { product } = this.localRegistration;
      const grouped = _.groupBy(product, (r) => `${r.memberType ? r.memberType : r.type}@${r.gender}`);
      return Object.keys(grouped).map((key) => {
        const memberType = key.split('@')[0];
        const gender = key.split('@')[1];
        return {
          key: key.includes('team') ? key.split('@')[0] : key,
          products: grouped[key],
          memberType,
          gender,
        };
      });
    },
    groupedByRegistrationType() {
      const { product } = this.localRegistration;
      const grouped = _.groupBy(product, (r) => r.type);
      return Object.keys(grouped).map((key) => {
        let header;
        switch (key) {
          case 'indv-to-team':
            header = 'Join a Team';
            break;
          case 'team':
            header = 'Register A Team';
            break;
          case 'indv':
            header = _.get(this.localRegistration, 'registrationType') === 'event' ? 'Register myself to an event or competition' : 'Become a Member';
            break;
          case 'entity'
            || 'entity-team':
            header = 'Register An Entity';
            break;
          case 'family':
            header = 'Register A Family';
            break;
          default:
            header = 'Other';
        }
        return {
          key,
          header,
          products: grouped[key],
        };
      });
    }
  },
  methods: {
    handleProductUpgradeClick(product) {
      // Create a temporary registration object with just this product
      const upgradeData = {
        ...this.localRegistration,
        selectedProduct: product
      };
      this.$emit('upgrade-click', upgradeData);
    },
    // Sticky header animation methods
    setupStickyObserver() {
      if (this.stickyObserver) {
        this.stickyObserver.disconnect();
      }

      // Create observer to watch when headers become sticky
      this.stickyObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const header = entry.target;
          if (header && header.classList.contains('sticky-section-header')) {
            const topValue = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--section-sticky-top') || '60', 10);
            if (entry.boundingClientRect.top <= topValue) {
              header.classList.add('is-sticky');
            } else {
              header.classList.remove('is-sticky');
            }
          }
        });
      }, {
        threshold: [0, 0.1, 0.5, 1],
        rootMargin: '0px'
      });

      // Observe all sticky section headers
      this.$nextTick(() => {
        const headers = this.$el.querySelectorAll('.sticky-section-header');
        headers.forEach((header) => {
          this.stickyObserver.observe(header);
        });
      });
    },

    // Mobile button helpers
    getActionButtonLabel(product) {
      const buttonLabel = this.getButtonLabel(product);
      if (buttonLabel === 'Register' && product.type === 'indv-to-team') return 'Join Team';
      if (buttonLabel === 'Register' && product.type === 'entity') return 'Register';
      if (buttonLabel === 'Register') return 'Register';
      return buttonLabel;
    },

    getStatusClass(product) {
      const label = this.getButtonLabel(product);
      return {
        'status-available': label === 'Register',
        'status-required': label === 'Required',
        'status-closed': label === 'Closed',
        'status-ineligible': label === 'Ineligible',
        'status-registered': label === 'Already Registered',
        'status-full': label === 'Full',
        'status-pay-now': label === 'Pay Now',
        'status-renew-now': label === 'Renew Now'
      };
    },

    getStatusIcon(product) {
      const label = this.getButtonLabel(product);
      switch (label) {
        case 'Register': return 'el-icon-circle-plus';
        case 'Renew Now': return 'el-icon-refresh';
        case 'Required': return 'el-icon-warning-outline';
        case 'Closed': return 'el-icon-lock';
        case 'Ineligible': return 'el-icon-circle-close';
        case 'Already Registered': return 'el-icon-circle-check';
        case 'Full': return 'el-icon-remove-outline';
        case 'Pay Now': return 'el-icon-credit-card';
        default: return '';
      }
    },

    isButtonDisabled(product) {
      const isRegistered = this.checkRegistered(product._id);
      const isPayAfter = this.checkPayAfter(product._id);
      const isEligible = this.isEligible(product);
      const fullSlot = this.checkFullSlot(product);
      const isRenewable = this.isRenewable(product);
      const canRegisterAgain = this.canRegisterAgain(product);
      return (isRegistered && !isPayAfter && !isRenewable && !canRegisterAgain) || !isEligible || fullSlot || !product.isActive || !product.isRegoOpen;
    },

    shouldShowIcon(product) {
      const label = this.getButtonLabel(product);
      return ['Required', 'Closed', 'Ineligible', 'Already Registered', 'Full'].includes(label);
    },

    // Dialog close handlers
    handleTeamDialogClose(done) {
      this.showTeamSelect = false;
      this.teamKeyword = '';
      done();
    },

    handleIndvTeamDialogClose(done) {
      this.showTeamSelectIndvToTeam = false;
      this.teamKeyword = '';
      this.tempProduct = null;
      done();
    },

    // Ultra-modern card helper methods
    // getStatusClass(product) {
    //   const label = this.getButtonLabel(product);
    //   if (label === 'Required') return 'required';
    //   if (label === 'Closed' || label === 'Registration is closed') return 'closed';
    //   if (label === 'Ineligible') return 'ineligible';
    //   return 'available';
    // },

    getPriceBadgeClass(product) {
      const price = product.price || 0;
      if (price === 0) return 'free';
      if (this.getButtonLabel(product) === 'Required') return 'required';
      if (price > 100) return 'premium';
      return '';
    },

    getButtonType(product) {
      const label = this.getButtonLabel(product);
      if (label === 'Required') return 'warning';
      if (label === 'Already Registered' || label === 'Pay Now') return 'success';
      return 'primary';
    },

    getButtonClass(product) {
      const label = this.getButtonLabel(product);
      if (label === 'Required') return 'required-btn';
      if (label === 'Already Registered' || label === 'Pay Now') return 'success-btn';
      return '';
    },

    getActionIcon(product) {
      const label = this.getButtonLabel(product);
      switch (label) {
        case 'Register': return 'el-icon-plus';
        case 'Required': return 'el-icon-warning-outline';
        case 'Join Team': return 'el-icon-user-solid';
        case 'Join Waitlist': return 'el-icon-time';
        case 'Already Registered': return 'el-icon-check';
        case 'Pay Now': return 'el-icon-credit-card';
        case 'Closed': return 'el-icon-lock';
        case 'Full': return 'el-icon-remove-outline';
        case 'Renew Now': return 'el-icon-refresh';
        default: return 'el-icon-right';
      }
    },

    // Mobile card helper methods
    canRegisterDirectly(product) {
      const label = this.getButtonLabel(product);
      return label === 'Register' && this.isEligible(product) && !this.checkFullSlot(product) && product.type !== 'indv-to-team' && !(product.familyMS && product.familyMS.length);
    },

    getStatusBannerClass(product) {
      const label = this.getButtonLabel(product);
      return {
        'status-required': label === 'Required',
        'status-ineligible': label === 'Ineligible',
        'status-closed': label === 'Closed' || label === 'Registration is closed',
        'status-full': label === 'Full',
        'status-registered': label === 'Already Registered'
      };
    },

    getStatusDescription(product) {
      const label = this.getButtonLabel(product);
      const member = this.selectedMember;

      switch (label) {
        case 'Required':
          // eslint-disable-next-line no-case-declarations
          const requiredMemberships = product.membershipProductsRequired || [];
          return `Complete ${requiredMemberships.length} membership${requiredMemberships.length > 1 ? 's' : ''} first`;

        case 'Ineligible':
          // eslint-disable-next-line no-case-declarations
          const reasons = [];
          if (member) {
            const age = this.calculateAge(member.profile.dob);
            if (age < product.ageFrom || age > product.ageTo) {
              reasons.push(`ages ${product.ageFrom}-${product.ageTo}`);
            }
            if (product.gender !== 'All' && member.profile.gender !== product.gender) {
              reasons.push(`${product.gender} only`);
            }
          }
          return reasons.length ? `For ${reasons.join(', ')}` : 'Not eligible';

        case 'Closed':
          return 'Registration period ended';

        case 'Full':
          return product.acceptWaitlist ? 'Join waitlist available' : 'No spots available';

        case 'Already Registered':
          return 'You are registered';

        default:
          return '';
      }
    },

    getDefaultProductName(product) {
      const parts = [];
      if (product.memberType) parts.push(this.getNationalMemberTypeName(product.memberType));
      if (product.gender && product.gender !== 'All') parts.push(product.gender);
      parts.push(`${product.ageFrom}-${product.ageTo !== 99 ? product.ageTo : '99+'} years`);
      return parts.join(' · ');
    },

    handleStatusAction(product) {
      const label = this.getButtonLabel(product);

      switch (label) {
        case 'Required': {
          // Just show a message - the actual handling is done in NewFinder.vue
          this.register(product._id);
          break;
        }
        case 'Ineligible':
          this.$message.warning('This member is not eligible for this registration');
          break;
        case 'Full':
          if (product.acceptWaitlist) {
            this.joinWaitlist(product._id);
          }
          break;
        case 'Pay Now':
          this.register(product._id);
          break;
        case 'Join Waitlist':
          this.joinWaitlist(product._id);
          break;
        case 'Renew Now':
          this.register(product._id);
          break;
        default:
          if (!this.isButtonDisabled(product)) {
            this.register(product._id);
          }
      }
    },

    shouldShowActionButton(product) {
      const label = this.getButtonLabel(product);
      // Don't show action buttons for these states - they'll use the status alert instead
      const nonActionableStates = ['Ineligible', 'Closed', 'Registration is closed', 'Already Registered'];
      return !nonActionableStates.includes(label);
    },

    getStatusAlertClass(product) {
      const label = this.getButtonLabel(product);
      return {
        'alert-ineligible': label === 'Ineligible',
        'alert-closed': label === 'Closed' || label === 'Registration is closed',
        'alert-registered': label === 'Already Registered'
      };
    },

    shouldShowStatusIcon(product) {
      const label = this.getButtonLabel(product);
      return ['Required', 'Closed', 'Ineligible'].includes(label);
    },

    // Popover-specific methods
    getFilteredTeamsForProduct(product) {
      if (product.type === 'indv-to-team' && this.filteredTeams) {
        return this.filteredTeams(product) || [];
      } if (product.type === 'team') {
        return this.allTeams || [];
      }
      return [];
    },

    selectTeam(team, product) {
      console.log('Team selected:', team, 'for product:', product);
      if (product.type === 'indv-to-team') {
        this.handleTeamSelectedMethod(team, product);
      } else if (product.type === 'team') {
        this.initRegisterTeam(team);
      }
    },

    showAllTeams(product) {
      // Fallback to full dialog if user wants to see all teams
      if (product.type === 'indv-to-team') {
        this.tempProduct = product;
        this.showTeamSelectIndvToTeam = true;
      } else if (product.type === 'team') {
        this.showTeamSelect = true;
      }
    },

    getMembership(membership) {
      // Navigate to the membership registration
      this.$emit('register', {
        ...this.localRegistration,
        products: [membership],
        memberId: this.selectedMember._id,
        productType: 'indv'
      });
    },

    toggleSection(sectionKey) {
      const index = this.activeTabNames.indexOf(sectionKey);
      if (index > -1) {
        // Remove if already active
        this.activeTabNames.splice(index, 1);
      } else {
        // Add if not active
        this.activeTabNames.push(sectionKey);
      }

      // Headers will be sticky automatically via CSS
    },

    handleCancelBulkRego() {
      this.bulkRegoDialog = false;
      this.selectedMembers = [];
      this.$emit('inOpenBulkRego', false);
    },
    updatePage(page, data) {
      this.addMemberModal.page = page;
      this.addMemberModal.data = data;
    },
    updateVisible(val) {
      this.addMemberModal.visible = val;
    },
    selectMember(member) {
      // Add member to selectedMembers
      this.selectedMembers = [...this.selectedMembers, member._id];
      // Add member to members array
      this.members = [member, ...this.members];
      // reset the addMemberModal
      this.addMemberModal.visible = false;
      this.addMemberModal.data = undefined;
      this.addMemberModal.page = {
        name: 'new-member',
        title: 'Add Member'
      };
      this.$nextTick(() => {
        const memberToSelect = this.members.find((m) => m._id === member._id);
        if (memberToSelect && this.$refs.bulkRegoTable) {
          this.$refs.bulkRegoTable.toggleRowSelection(memberToSelect, true);
        }
      });
    },
    importedMembers(members) {
      // add members to this.members
      this.members = [...members, ...this.members];
      this.addMemberModal.visible = false;
      this.addMemberModal.data = undefined;
      this.addMemberModal.page = {
        name: 'new-member',
        title: 'Add Member'
      };
      this.addMoreMembersDialog = false;
      // get all member id and add to selectedMembers
      const ids = members.map((member) => member._id);
      this.selectedMembers = [...new Set([...this.selectedMembers, ...ids])];
      // Update the table selection
      this.$nextTick(() => {
        this.selectedMembers.forEach((memberId) => {
          const member = this.members.find((m) => m._id === memberId);
          if (member) {
            this.$refs.bulkRegoTable.toggleRowSelection(member, true);
          }
        });
      });
    },
    getNationalMemberTypeName(memberType) {
      const memberTypes = this.$store.getters['national/memberTypes'];
      const foundType = memberTypes.find((mt) => mt.type === memberType);
      return foundType ? foundType.name : memberType;
    },
    debounceSearch: _.debounce(function () {
      this.$forceUpdate();
    }, 300),
    toggleDescription() {
      this.isDescriptionExpanded = !this.isDescriptionExpanded;
      this.$nextTick(() => {
        const description = this.$refs.mobileDescription;
        if (!description) return;
        if (this.isDescriptionExpanded) {
          description.style.maxHeight = `${description.scrollHeight}px`;
        } else {
          description.style.maxHeight = '100px';
        }
      });
    },
    updateStickyHeaderPositions() {
      if (window.innerWidth > 1024) return;

      // Use setTimeout to ensure the drawer header is fully rendered
      this.$nextTick(() => {
        setTimeout(() => {
          // Calculate the offset based on whether we're in a drawer or regular view
          const drawerHeader = document.querySelector('.mobile-event-drawer .drawer-header');
          const eventStickyHeader = document.querySelector('.sticky-event-header');
          let topOffset = 0;

          if (drawerHeader) {
            // We're in a drawer - position directly below drawer header
            topOffset = 0;
            console.log('drawerHeader', drawerHeader);

            console.log('Drawer header found, offsetHeight:', drawerHeader.offsetHeight, 'using offset:', topOffset);
          } else if (eventStickyHeader && eventStickyHeader.classList.contains('sticky-visible')) {
            // We're in regular view - use the sticky event header height
            topOffset = eventStickyHeader.offsetHeight;
            console.log('Sticky header found, height:', topOffset);
          } else {
            // Default fallback with buffer
            topOffset = 64; // 60 + 4px buffer
            console.log('No header found, using default:', topOffset);
          }

          // Update CSS custom property for sticky positioning
          document.documentElement.style.setProperty('--section-sticky-top', `${topOffset}px`);
          console.log('Updated --section-sticky-top to:', topOffset);
        }, 150); // Increased timeout for better reliability
      });
    },
    handleDrawerExpandAllChanged(expandAll) {
      // Update local state and expand/collapse accordingly
      this.isAllExpanded = expandAll;
      if (expandAll) {
        this.expandAllProducts();
      } else {
        this.collapseAllProducts();
      }
    },
    checkDescriptionHeight() {
      this.isMobile = window.innerWidth <= 767;
      this.$nextTick(() => {
        const description = this.$refs.mobileDescription;
        if (!description) return;
        this.showExpandIcon = (description.scrollHeight || 0) > 100;
      });
      // Also update sticky positions when window resizes
      this.updateStickyHeaderPositions();
    },
    getDisplayName(team, product) {
      const isEligible = this.isEligible(product);
      const fullSlot = this.checkFullIndvTeamSlot(product, team._id);
      const isRegistered = this.checkIndvTeamRegistered(product, team._id);
      const waitlistEnabled = this.checkIsWaitlistOpenIndvToTeam(product, team._id);
      if (isRegistered) {
        return `${team.name} (Registered)`;
      }
      if (waitlistEnabled) {
        return `${team.name} (Join Waitlist)`;
      }
      if (fullSlot) {
        return `${team.name} (Full)`;
      }
      if (!isEligible) {
        return `${team.name} (Ineligible)`;
      }
      return team.name;
    },
    getRowClassName(product) {
      // Return a function that takes the row and rowIndex
      return ({ row }) => {
        // Example condition: apply 'disabled-row' if 'isDisabled' is true
        const isEligible = this.isEligible(product);
        const fullSlot = this.checkFullIndvTeamSlot(product, row._id);
        const isRegistered = this.checkIndvTeamRegistered(product, row._id);
        const waitlistEnabled = this.checkIsWaitlistOpenIndvToTeam(product, row._id);
        if (waitlistEnabled) {
          return '';
        }
        if (isRegistered || fullSlot || !isEligible) {
          return 'disabled-row';
        }
        return '';
      };
    },
    cancelFamilyRego() {
      _.each(this.familyMSList, (fam) => {
        // eslint-disable-next-line no-param-reassign
        fam.memberId = undefined;
      });
      this.familyMSDialog = false;
      this.selectedFamilyMember = false;
    },
    formatDuration(registration) {
      const year = _.get(registration, 'durationYear', 0);
      const month = _.get(registration, 'durationMonth', 0);
      const day = _.get(registration, 'durationDay', 0);
      const startDate = moment(Date.now());
      if (startDate) {
        const momentStartAdd = moment(startDate).add(year, 'years').add(month, 'months').add(day, 'days');
        const formatted = momentStartAdd.format('DD MMM YYYY');
        return `${this.dateFormatter(startDate)} - ${this.dateFormatter(formatted)}`;
      }
      return '';
    },
    formatExpiry(expiry) {
      if (expiry) {
        return `Expires at ${this.dateFormatter(expiry)}`;
      }
      return '';
    },
    formatStartDate(startDate, endDate) {
      if (_.isEmpty(startDate)) {
        return '';
      }
      if (endDate) {
        return this.dateFormatter(startDate);
      }
      return `Starts ${this.dateFormatter(startDate)}`;
    },
    formatEndDate(endDate) {
      if (endDate) {
        return `- ${this.dateFormatter(endDate)}`;
      }
      return '';
    },
    getButtonLabel(product) {
      const isMembershipRequired = this.isMembershipRequired(product);
      const isRenewable = this.isRenewable(product);
      const canRegisterAgain = this.canRegisterAgain(product);
      const isAccreditationRequired = this.isAccreditationRequired(product);
      const isRegistered = this.checkRegistered(product._id);
      // const isMembershipRequiredRegistered = this.checkRegisteredMembershipRequired(product._id);
      const isPayAfter = this.checkPayAfter(product._id);

      const isEligible = this.isEligible(product);
      const fullTeamSlot = this.checkFullSlot(product);
      const isWaitlistOpen = this.checkIsWaitlistOpen(product);

      const isIndvToTeamAndWaitlist = product.type === 'indv-to-team' && isWaitlistOpen;

      if (isRegistered && !isPayAfter && !isRenewable && !canRegisterAgain) {
        return 'Already Registered';
      }
      if (!isEligible) {
        return 'Ineligible';
      }
      if (isWaitlistOpen && _.get(product, 'type') !== 'indv-to-team') {
        return 'Join Waitlist';
      }
      if (fullTeamSlot && !isIndvToTeamAndWaitlist) {
        return 'Full';
      }
      if (!product.isActive || !product.isRegoOpen) {
        return 'Closed';
      }
      if (isMembershipRequired) {
        return 'Required';
      }
      if (isAccreditationRequired && !isRegistered) {
        return 'Accreditation';
      }
      if (isRegistered && isPayAfter) {
        return 'Pay Now';
      }
      if (isRegistered && isRenewable) {
        return 'Renew Now';
      }
      if (product.type === 'indv-to-team') {
        return 'Join';
      }
      return 'Register';
    },
    isRenewable(product) {
      const found = this.memberMembership
        .find((m) => _.get(m, 'regoEntity.products._id') === product._id && m.regoEntity.isRenewable);
      if (found) {
        return true;
      }

      // Check pending registrations for early renewal eligibility based on event start date
      const pendingRegos = this.$store.getters['cart/pendingRequiredRegos'];

      // Check each pending registration to see if it has checkExpiryFromEventStart
      // eslint-disable-next-line no-restricted-syntax
      for (const pendingRego of pendingRegos) {
        if (_.get(pendingRego, 'meta.checkExpiryFromEventStart')) {
          const eventStartDate = _.get(pendingRego, 'startDate');

          if (eventStartDate) {
            // Find active membership for this product (the membership required product)
            const activeMembership = this.memberMembership
              .find((m) => _.get(m, 'regoEntity.products._id') === product._id
                && !m.expired
                && m.expiry);

            if (activeMembership) {
              // Convert dates to timestamps for comparison
              const membershipExpiryTimestamp = new Date(activeMembership.expiry).getTime();
              const eventStartTimestamp = new Date(eventStartDate).getTime();

              // If membership expires before event starts, allow early renewal
              if (membershipExpiryTimestamp < eventStartTimestamp) {
                return true;
              }
            }
          }
        }
      }

      return false;
    },
    canRegisterAgain(product) {
      const found = this.memberMembership
        .find((m) => _.get(m, 'regoEntity.products._id') === product._id && m.regoEntity.canRegisterAgain);
      if (found) {
        return true;
      }
      return false;
    },
    handleCardClicked(product) {
      // const isMembershipRequired = this.isMembershipRequired(product);
      const isRegistered = this.checkRegistered(product._id);
      const isRenewable = this.isRenewable(product);
      const isPayAfter = this.checkPayAfter(product._id);
      const isEligible = this.isEligible(product);
      const fullSlot = this.checkFullSlot(product);

      if (isRegistered && !isPayAfter && !isRenewable) {
        this.$notify({
          title: 'Already Registered',
          message: 'You are already registered for this product..',
          type: 'success',
          duration: 5000,
        });
        return;
      }
      if (!isEligible) {
        this.$notify({
          title: 'Ineligible',
          message: 'You are not eligible to register for this product.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (!product.isActive || !product.isRegoOpen) {
        this.$notify({
          title: 'Registration Closed',
          message: 'Registration for this product is closed. Please contact your administrator.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      // if (isMembershipRequired && !isRegistered) {
      //   this.$message.error('You must be a member to register for this product');
      //   return;
      // }

      if (fullSlot) {
        this.$notify({
          title: 'Full',
          message: 'This product is full.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (product.type === 'indv-to-team') {
        if (this.filteredTeams(product).length > 0) {
          // You might want to show some modal or UI component here for the user to choose a team
          // Example:
          this.tempProduct = product;
          this.showTeamSelectIndvToTeam = true;
        } else {
          this.$notify({
            title: 'No Teams Available',
            message: 'There are no teams available for this product.',
            type: 'warning',
            duration: 5000,
          });
        }
      } else if (product.type === 'entity') {
        // Similar to the above, you might want to show some modal or UI component here for the user to choose an entity
        // Example:
        // this.showEntitySelectionModal(product);
      } else {
        // This is for the default case where it's just a button.
        // Checking the conditions before actually registering
        // eslint-disable-next-line no-lonely-if
        if (!(this.checkRegistered(product._id) && !this.checkPayAfter(product._id) && !this.isRenewable(product))
          && !this.checkFullSlot(product)
          && this.isEligible(product)) {
          this.register(product._id);
        } else {
          // You can also add a feedback mechanism here for why the user cannot register
          this.$notify({
            title: 'Cannot Register',
            message: 'You cannot register for this product.',
            type: 'warning',
            duration: 5000,
          });
        }
      }
    },
    searchByTag(tag) {
      // start search for events
      this.$emit('searchByTag', tag);
    },
    expandAllProducts() {
      const allKeys = this.groupedByRegistrationType.map((item) => item.key);
      this.activeTabNames = allKeys;
      this.isAllExpanded = true;
      this.$forceUpdate();
    },
    collapseAllProducts() {
      this.activeTabNames = [];
      this.isAllExpanded = false;
      this.$forceUpdate();
    },
    async createNewTeam() {
      // const customEntity = {
      //   _id: this.localRegistration.orgtree[this.localRegistration.entityType]._id,
      //   name: this.localRegistration.orgtree[this.localRegistration.entityType].name
      // };
      // const foundEntity = this.$store.getters['national/getEntity'];
      // if (foundEntity && foundEntity._id && foundEntity.name !== '') {
      //   customEntity = {
      //     _id: foundEntity._id,
      //     name: foundEntity.name,
      //     level: foundEntity.level
      //   };
      // }
      // const searchResult = await this.$http.post('/assemble/api/v1/portal/registrations/new-search/20/1', {
      //   criteria: '',
      //   filters: {
      //     membershipType: 'entity-team',
      //     entityType: 'membership'
      //   },
      //   customEntity
      // });
      // const registration = searchResult.data.data.result[0];
      // let teamProduct = [];
      // return error if no registration found
      // if (!registration) {
      //   this.$message.error(`No entity membership is found for ${customEntity.name}, please contact your administrator`);
      //   return;
      // } if (registration) {
      //   // filter out the team product
      //   teamProduct = registration.products.filter((p) => _.some(p.entityTypeList, { type: 'team' }));
      //   if (teamProduct.length === 0) {
      //     this.$message.error(`No team product is found for ${customEntity.name}, please contact your administrator`);
      //     return;
      //   }
      // }
      const regoObj = this.generateRegoObject(this.selectedProductArr);
      this.$emit('register', regoObj);
    },

    checkTeamRegistered(team) {
      const foundTeam = _.get(this, 'localRegistration.teams', []).find((t) => t._id === team._id);
      return !!foundTeam;
    },
    initRegisterTeam(row) {
      if (!row.isMyTeam) {
        this.registeringTeam = row;
        this.teamPasscodeDialog = true;
      } else {
        this.registerTeam(row);
      }
    },
    checkPasscode(passcode) {
      this.$http.get(`/assemble/api/v1/portal/team/${this.registeringTeam._id}/check-passcode/${passcode}`, {
        passcode,
      }).then(() => {
        this.registerTeam(this.registeringTeam);
        this.teamPasscodeDialog = false;
      }).catch(() => {
        this.$notify({
          title: 'Invalid Passcode',
          message: 'The passcode you entered is invalid. Please try again.',
          type: 'error',
          duration: 5000,
        });
      });
    },
    validateTeamPasscode() {
      if (!this.teamPasscodeInput || this.teamPasscodeInput.length !== 6) {
        this.passcodeError = 'Please enter a 6-digit access code';
        return;
      }

      const enteredCode = parseInt(this.teamPasscodeInput, 10);
      const requiredCode = _.get(this.selectedTeamForPasscode, 'meta[0].teamCode');

      if (enteredCode === requiredCode) {
        // Passcode is correct, proceed with team registration
        this.teamPasscodeDialog = false;
        this.proceedWithTeamRegistration();
      } else {
        this.passcodeError = 'Invalid access code. Please check with your team administrator.';
      }
    },
    clearPasscodeError() {
      this.passcodeError = '';
    },
    proceedWithTeamRegistration() {
      const { selectedTeamForPasscode, selectedProductForPasscode } = this;
      const filteredProducts = this.localRegistration.product.filter((p) => p._id === selectedProductForPasscode._id);

      // Check if bulk registration is allowed
      if (selectedProductForPasscode.bulkRegoAllowed) {
        this.$confirm('Do you want to register multiple members to this team?', 'Confirmation', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          // If user confirms, open bulk registration dialog
          this.bulkRegoDialog = true;
          this.$emit('inOpenBulkRego', true);
          this.selectedProductArr = filteredProducts;
          [this.selectedProduct] = filteredProducts;
          this.selectedTeamForBulkRego = selectedTeamForPasscode;
        }).catch(() => {
          // If user cancels, proceed with single member registration
          this.registerSingleMemberToTeam(filteredProducts, selectedTeamForPasscode._id);
        });
      } else {
        // If bulk registration is not allowed, proceed with single member registration
        this.registerSingleMemberToTeam(filteredProducts, selectedTeamForPasscode._id);
      }
    },
    registerTeam(row) {
      const regoObj = this.generateRegoObject(this.selectedProductArr, null, null, row);
      this.$emit('register', regoObj);
    },
    registerEntity(row) {
      const { entityId, productId } = this.selectedEntity;
      const filteredProducts = this.localRegistration.product.filter((p) => p._id === productId);
      const regoObj = this.generateRegoObject(filteredProducts, null, entityId, null, null, row);
      this.$emit('register', regoObj);
    },
    getOrgtree(row) {
      if (!row.orgtree) return;

      const { orgtree } = row;
      // display all keys from orgTree object
      const orgTreeKeys = Object.keys(orgtree);
      const orgTreeValues = Object.values(orgtree);
      const orgTreeArray = [];
      orgTreeKeys.forEach((key, index) => {
        orgTreeArray.push(`${_.capitalize(key)}: ${orgTreeValues[index].name}`);
      });
      // return each key value pair in a new line
      // eslint-disable-next-line consistent-return
      return orgTreeArray.join(' |  ');
    },
    getFirstOrgtree(row) {
      if (!row.orgtree) return;

      const { orgtree } = row;
      // display all keys from orgTree object
      const orgTreeKeys = Object.keys(orgtree);
      const orgTreeValues = Object.values(orgtree);
      const orgTreeArray = [];
      orgTreeKeys.forEach((key, index) => {
        orgTreeArray.push(`${orgTreeValues[index].name}`);
      });
      // return each key value pair in a new line
      // eslint-disable-next-line consistent-return
      return orgTreeArray[0];
    },
    async searchTeam() {
      this.$store.commit('loading', true, 'Loading teams...');
      // this.$store.commit('loadingText', 'Loading teams...');
      const res = await this.$http.post('/assemble/api/v1/portal/teams/search-entity', {
        teamKeyword: this.teamKeyword,
      });
      this.$store.commit('loading', false);

      const resTeam = res.data.data;
      // get user ID
      const userId = this.$store.getters['user/userId'];
      // sort by user's team first
      const userTeams = resTeam.filter((t) => t.createdBy.length && t.createdBy[0]._id === userId);
      // add flag to indicate user's team
      userTeams.forEach((t) => {
        // eslint-disable-next-line no-param-reassign
        t.isMyTeam = true;
      });
      if (this.teamKeyword === '') {
        this.allTeams = userTeams;
      } else {
        const otherTeams = resTeam ? resTeam.filter((t) => !t.createdBy.length || t.createdBy[0]._id !== userId) : [];
        this.allTeams = userTeams.concat(otherTeams);
      }
    },
    async searchEntity() {
      const { entityType } = this.selectedEntity;
      this.$store.commit('loading', true, 'Loading entities...');
      // this.$store.commit('loadingText', 'Loading teams...');
      const res = await this.$http.post(`/assemble/api/v1/portal/${entityType}/search-entity`, {
        teamKeyword: this.teamKeyword,
      });
      this.$store.commit('loading', false);

      const resTeam = res.data.data;
      // get user ID
      const userId = this.$store.getters['user/userId'];
      // sort by user's team first
      const userTeams = resTeam.filter((t) => t.createdBy.length && t.createdBy[0]._id === userId);
      // add flag to indicate user's team
      userTeams.forEach((t) => {
        // eslint-disable-next-line no-param-reassign
        t.isMyTeam = true;
      });
      const otherTeams = resTeam.filter((t) => !t.createdBy.length || t.createdBy[0]._id !== userId);

      this.allEntities = userTeams.concat(otherTeams);
    },
    calculateAge(dob, customEndOfYear = false, ageCalculationType = 'default') {
      console.log({ customEndOfYear, ageCalculationType });
      const nationalEndOfYear = this.$store.getters['national/endOfYear'];
      // eslint-disable-next-line no-nested-ternary
      const endOfYear = ageCalculationType === 'specific'
        ? customEndOfYear
        // eslint-disable-next-line no-nested-ternary
        : ageCalculationType === 'registration'
          ? moment().format('YYYY-MM-DD')
          : ageCalculationType === 'default' && !customEndOfYear
            ? nationalEndOfYear
            : customEndOfYear;
      const age = calculateMemberAge(dob, endOfYear);
      return age;
    },
    async joinWaitlist(productId) {
      const eventId = this.localRegistration._id;
      const entityType = this.localRegistration.registrationType;
      this.$emit('joinWaitList', productId, eventId, entityType);
    },

    checkIsWaitlistOpen(product) {
      return product.acceptWaitlist && (this.checkFullSlot(product) && !this.checkRegistered(product._id)) && this.isEligible(product);
    },
    checkIsWaitlistOpenIndvToTeam(product, teamId) {
      return product.acceptWaitlist && (this.checkFullIndvTeamSlot(product, teamId) && !this.checkIndvTeamRegistered(product, teamId)) && this.isEligible(product);
    },
    checkFullSlot(product) {
      // get items in the cart
      const pendingRegos = this.$store.getters['cart/registrations'];
      const numberOfSameProduct = pendingRegos.filter((r) => r.product._id === product._id).length;
      const foundProduct = this.localRegistration.product.find((p) => p._id === product._id);
      const isNoMax = _.get(this, 'localRegistration.noMax');
      const maxRegoCond = _.get(foundProduct, 'maxRego', 0) > 0;
      // const maxNoIndvTeamCond = _.get(foundProduct, 'maxNoIndvTeam') || _.get(foundProduct, 'maxNoIndvTeam') === 0;
      if (!foundProduct) return false;
      if (foundProduct.type === 'team' && (!isNoMax || maxRegoCond)) {
        const teamProduct = _.find(_.get(this.localRegistration, 'teamProducts'), (tp) => tp._id === foundProduct._id);
        // const teams = _.get(this, 'localRegistration.teams', []).filter((t) => t._id);
        const teams = _.get(teamProduct, 'teamRegistrations', []);
        // const teamsFromProduct = _.filter(teams, (t) => _.get(t, 'productMeta.teamProductId') === foundProduct._id);
        const numOfTeams = teams.length + numberOfSameProduct;
        const numOfTeamsFromProduct = teams.length + numberOfSameProduct;
        const maxNoTeams = _.get(this, 'localRegistration.maxNoTeams');
        const productMaxNoRego = _.get(foundProduct, 'maxRego', 0);
        const regosGTEntityMaxRego = !isNoMax && numOfTeams !== 0 && maxNoTeams !== 0 && numOfTeams >= maxNoTeams;
        const regosGTProductMaxRego = (productMaxNoRego > 0 && numOfTeamsFromProduct && numOfTeamsFromProduct >= productMaxNoRego);

        if (regosGTProductMaxRego || regosGTEntityMaxRego) {
          return true;
        }
        // if (teamsGTMaxNoTeams) {
        //   return true;
        // }
      }
      if (foundProduct.type === 'indv-to-team' && !isNoMax) {
        const registrationCounts = _.get(this, 'localRegistration.registrationCounts', {});
        const maxNoIndvTeam = _.get(this, 'localRegistration.maxNoIndvTeam');

        const indvToTeamCount = _.get(registrationCounts, 'indvToTeamPerProduct', [])
          .reduce((total, item) => total + item.count, 0);
        const regoIndvTeam = indvToTeamCount + numberOfSameProduct;
        // const regoIndvTeamSameProd = _.filter(regos, (r) => r.productType === 'indv-to-team' && _.get(r, 'productId') === foundProduct._id).length + numberOfSameProduct;
        // const productMaxNoRego = _.get(foundProduct, 'maxNoIndvTeam');
        const regosGTEntityMaxRego = !isNoMax && regoIndvTeam >= maxNoIndvTeam;
        // const regosGTProductMaxRego = (productMaxNoRego && regoIndvTeamSameProd && regoIndvTeamSameProd >= productMaxNoRego) || productMaxNoRego === 0;

        if (regosGTEntityMaxRego) {
          return true;
        }
        // if (regoIndvTeam >= maxNoIndvTeam) {
        //   return true;
        // }
      }
      if ((foundProduct.type === 'indv' || foundProduct.type === 'family') && (!isNoMax || maxRegoCond)) {
        const registrationCounts = _.get(this, 'localRegistration.registrationCounts', {});
        // const maxProductRego = _.get(foundProduct, 'maxRego', 0);
        const noOfIndv = _.get(registrationCounts, 'totalIndv', 0) + numberOfSameProduct;
        const productCount = _.get(registrationCounts, 'indvPerProduct', [])
          .find((item) => item.productId === foundProduct._id);
        const noOfIndvSameProd = (productCount ? productCount.count : 0) + numberOfSameProduct;
        const maxNoIndv = _.get(this, 'localRegistration.maxNoIndividuals');

        const productMaxNoRego = _.get(foundProduct, 'maxRego', 0);
        const regosGTEntityMaxRego = !isNoMax && noOfIndv >= maxNoIndv;
        const regosGTProductMaxRego = (productMaxNoRego > 0 && noOfIndvSameProd && noOfIndvSameProd >= productMaxNoRego);

        if (regosGTProductMaxRego || regosGTEntityMaxRego) {
          return true;
        }
        // if (noOfIndv !== 0 && maxNoIndv !== 0 && noOfIndv >= maxNoIndv) {
        //   return true;
        // }
        // if (maxProductRego !== 0 && noOfIndv >= maxProductRego) {
        //   return true;
        // }
      }
      return false;
    },
    checkFullIndvTeamSlot(product, teamId) {
      const pendingRegos = this.$store.getters['cart/registrations'];
      const numberOfSameProduct = pendingRegos.filter((r) => r.product._id === product._id).length;
      const foundProduct = this.localRegistration.product.find((p) => p._id === product._id);
      const registrationCounts = _.get(this, 'localRegistration.registrationCounts', {});
      const maxProductNoIndvTeam = _.get(foundProduct, 'maxNoIndvTeam', 0);

      // Get existing registrations count for this specific product and team
      const indvToTeamForProduct = _.get(registrationCounts, 'indvToTeamPerProduct', [])
        .find((item) => item.productId === product._id && item.teamId === teamId);
      const regoIndvTeam = (indvToTeamForProduct ? indvToTeamForProduct.count : 0) + numberOfSameProduct;

      // Find the team and get eventMembers count
      const team = _.get(this, 'localRegistration.teams', []).find((t) => t._id === teamId);
      let eventMembersCount = 0;

      if (team && team.meta && team.meta[0] && team.meta[0].eventMembers) {
        const eventId = this.localRegistration._id;
        const { memberType } = product;

        // Filter eventMembers by eventId and memberType
        eventMembersCount = team.meta[0].eventMembers.filter((member) => member.eventId === eventId && member.memberType === memberType).length;
      }

      // Total count includes registrations + eventMembers
      const totalCount = regoIndvTeam + eventMembersCount;

      if (foundProduct.type === 'indv-to-team' && maxProductNoIndvTeam !== 0) {
        if (totalCount >= maxProductNoIndvTeam) {
          return true;
        }
      }
      return false;
    },
    checkPayAfter(productId) {
      const found = this.memberMembership
        .filter((m) => _.get(m, 'regoEntity.products._id') === productId
          && m.expired !== true
          && (!m.approvalStatus || (m.approvalStatus !== 'pending' && m.approvalStatus !== 'declined')));
      if (found.length) {
        const registration = found[0];

        // Check for payAfter registrations that are not fully paid
        if (registration.payAfter && registration.payAfterMeta && registration.payAfterMeta.fullyPaid === false) {
          return true;
        }

        // Check for payLater registrations that are not fully paid
        if (registration.payLater && _.get(registration, 'payLaterMeta.fullyPaid') === false) {
          return true;
        }

        // Check if charged array is empty or doesn't exist
        const charged = _.get(registration, 'charge', []);
        console.log('charged', charged);

        // Check if the product has a price, payLater is enabled, but charged amount is 0 and not manually added
        const productPrice = _.get(registration, 'regoEntity.products.price', 0);
        const chargedTotal = charged.reduce((sum, item) => sum + (item.amount || 0), 0);
        console.log('chargeTotal', chargedTotal);

        const isManuallyAdded = _.get(registration, 'isManual', false);
        if (productPrice > 0 && registration.payLater && chargedTotal === 0 && !isManuallyAdded) {
          return true;
        }
      }
      return false;
    },
    generateTagSignature(tags) {
      return tags && tags.length > 0
        ? tags.map((tag) => tag._id).sort().join(',')
        : '';
    },
    isMembershipRequired(product) {
      if (product.type === 'team') return false;
      if (product.isMembershipRequired) {
        // Create sets of concatenated feature strings for efficient lookup
        const requiredFeatureStrings = new Set();
        const memberFeatureStrings = new Set();

        // Check if we need to validate against event start date
        const checkExpiryFromEvent = this.localRegistration.meta?.checkExpiryFromEventStart === true;
        const eventStartDate = checkExpiryFromEvent ? moment(this.localRegistration.startDate).valueOf() : null;

        // Build a map to track which requirements need event date checking
        const requirementExpiryRules = new Map();

        // Build required membership feature strings
        product.membershipProductsRequired.forEach((pr) => {
          const tagSig = this.generateTagSignature(pr.products.tags);
          const featureString = pr.products._id
            ? `productId:${pr.products._id}|membershipId:${pr._id}`
            : `${pr._id}|${pr.products.type}|${pr.products.memberType}|${tagSig}`;

          requiredFeatureStrings.add(featureString);

          // Track if this requirement needs event date checking
          const needsEventDateCheck = checkExpiryFromEvent && eventStartDate;
          requirementExpiryRules.set(featureString, needsEventDateCheck ? eventStartDate : moment().valueOf());
        });

        // Build member membership feature strings and collect valid memberships
        const validMemberships = [];
        this.memberMembership.forEach((m) => {
          // Early exit for already expired memberships - they can't be valid for ANY date
          if (m.expired === true || m.expiry < moment().valueOf()
              || (m.approvalStatus && (m.approvalStatus === 'pending' || m.approvalStatus === 'declined'))) {
            return;
          }

          // Create feature strings for both product ID and legacy comparison
          const memberTagSig = this.generateTagSignature(_.get(m, 'regoEntity.products.tags', []));
          const memberFeatureString = `${m.entityId}|${m.productType}|${m.memberType}|${memberTagSig}`;
          const productIdFeatureString = m.productId ? `productId:${m.productId}|membershipId:${m.entityId}` : null;

          // Check if this membership matches any required membership and meets expiry requirements
          let isValidForRequirement = false;

          if (requiredFeatureStrings.has(memberFeatureString)) {
            // Check if membership expiry meets the requirement's specific date
            const requiredExpiryDate = requirementExpiryRules.get(memberFeatureString);
            if (requiredExpiryDate && m.expiry >= requiredExpiryDate) {
              isValidForRequirement = true;
            }
          }

          if (productIdFeatureString && requiredFeatureStrings.has(productIdFeatureString)) {
            const requiredExpiryDate = requirementExpiryRules.get(productIdFeatureString);
            if (requiredExpiryDate && m.expiry >= requiredExpiryDate) {
              isValidForRequirement = true;
            }
          }

          if (isValidForRequirement) {
            memberFeatureStrings.add(memberFeatureString);
            if (productIdFeatureString) {
              memberFeatureStrings.add(productIdFeatureString);
            }
            validMemberships.push(m);
          }
        });

        const pendingRegos = this.$store.getters['cart/registrations'];

        // Check pending registrations using feature strings
        const pendingFeatureStrings = new Set();
        pendingRegos.forEach((rego) => {
          if (rego.memberId === this.selectedMember._id) {
            const pendingTagSig = this.generateTagSignature(rego.product.tags);

            // Add legacy feature string
            const legacyFeatureString = `${rego.product._id}|${rego.product.type}|${rego.product.memberType}|${pendingTagSig}`;
            pendingFeatureStrings.add(legacyFeatureString);

            // Add productId feature string if entityId exists
            if (rego.product._id && rego.entityId) {
              const productIdFeatureString = `productId:${rego.product._id}|membershipId:${rego.entityId}`;
              pendingFeatureStrings.add(productIdFeatureString);
            }
          }
        });

        const requiredMembershipInPendingRegos = [...requiredFeatureStrings].some((required) => pendingFeatureStrings.has(required));

        if (!validMemberships.length && !requiredMembershipInPendingRegos) {
          return true;
        }
      }
      return false;
    },
    isAccreditationRequired(product) {
      if (product.isAccreditationRequired) {
        const accreditationIds = _.map(_.get(product, '.accreditationProductsRequired', []), (a) => a._id);
        this.$http.post('/assemble/api/v1/portal/registrations/member-accreditations', { accreditationIds }) // eslint-disable-next-line
          .then((res) => {
            this.$store.commit('loading', false);
            const accredMemberIds = res.data.data;
            if (!_.includes(accredMemberIds, this.selectedMember._id)) {
              return true;
            }
            return false;
          }).catch((e) => {
            this.$message.error(e.response.data.message);
            this.$store.commit('loading', false);
          });
      }
      return false;
    },

    async requestAccess() {
      const userId = this.$store.getters['user/userId'];

      const res = await this.$http.post('/assemble/api/v1/portal/registrations/product/request-password', {
        userId,
        productId: this.selectedProduct._id
      });
      if (res.data.data) this.$message.success('Request sent successfully!');
    },
    async authProduct() {
      const { password } = this.product;

      this.$refs.productPassForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await this.$http.post('/assemble/api/v1/portal/registrations/product/auth', {
              password,
              productId: this.selectedProduct._id
            });
            if (res.data.data) {
              const productArr = [this.selectedProduct];
              const regoObj = this.generateRegoObject(productArr);
              this.closePasswordPopover();
              this.$emit('register', regoObj);
              return true;
            }
            this.errorMessage = 'Incorrect password';
            return false;
          } catch (error) {
            // this.$message.error('Invalid password');
            this.errorMessage = 'Invalid password';
            datadogRum.addError(error);
          }
        }
        return false;
      });
    },
    showPasswordPopover(event) {
      // Clear any previous state
      this.errorMessage = undefined;
      this.product.password = undefined;

      // Position the popover relative to the clicked button
      if (event && event.target) {
        const newClickedButton = event.target.closest('.el-button') || event.target;

        // If popover is already showing, close it first
        if (this.showAuthProduct) {
          this.showAuthProduct = false;

          // Wait for the popover to close completely
          this.$nextTick(() => {
            // Update the reference element
            this.clickedButton = newClickedButton;

            // Wait a bit more then show the popover with new reference
            setTimeout(() => {
              if (this.$refs.passwordPopover) {
                this.$refs.passwordPopover.referenceElm = this.clickedButton;
                this.$refs.passwordPopover.doDestroy();

                this.$nextTick(() => {
                  this.$refs.passwordPopover.updatePopper();
                  this.showAuthProduct = true;
                });
              }
            }, 150);
          });
        } else {
          // First time showing - just set the reference and show
          this.clickedButton = newClickedButton;

          this.$nextTick(() => {
            if (this.$refs.passwordPopover) {
              this.$refs.passwordPopover.referenceElm = this.clickedButton;
              this.$refs.passwordPopover.updatePopper();
              this.showAuthProduct = true;
            }
          });
        }
      }
    },
    hidePasswordTrigger() {
      const trigger = document.getElementById('password-popover-trigger');
      if (trigger) {
        trigger.style.display = 'none';
      }
    },
    closePasswordPopover() {
      this.showAuthProduct = false;
      this.clickedButton = null;
      this.errorMessage = undefined;
      this.product.password = undefined;
      this.hidePasswordTrigger();
    },
    checkProductVisibility(product) {
      if (this.privateProps.entityId && this.privateProps.productId) return true;
      if (_.get(product, 'isPrivate')) {
        if (product.isVisible !== undefined) {
          if (product.isVisible) return true;
          return false;
        }
      }
      return true;
    },
    checkRegistered(productId) {
      const product = this.localRegistration.product.find((p) => p._id === productId);
      const multipleRegoAllowed = this.$store.getters['national/getMultipleRegoAllowed'];
      const found = this.memberMembership
        .filter((m) => _.get(m, 'regoEntity.products._id') === productId
          && m.expired !== true);
      if (found.length) {
        if (multipleRegoAllowed && product.type === 'indv-to-team') {
          return false;
        }
        // return true and the found membership
        return true;
      }

      return false;
    },

    checkRegisteredMembershipRequired(productId) {
      const product = this.localRegistration.product.find((p) => p._id === productId);
      const multipleRegoAllowed = this.$store.getters['national/getMultipleRegoAllowed'];
      const found = this.memberMembership
        .filter((m) => {
          const membershipProductsRequired = _.get(product, 'membershipProductsRequired', []);
          const membershipProductsRequiredIds = _.map(membershipProductsRequired, 'products._id');
          const condition = _.includes(membershipProductsRequiredIds, _.get(m, 'regoEntity.products._id'))
            && m.expired !== true
            && (!m.approvalStatus || (m.approvalStatus !== 'pending' && m.approvalStatus !== 'declined'));
          return condition;
        });
      if (found.length) {
        if (multipleRegoAllowed && product.type === 'indv-to-team') {
          return false;
        }
        // return true and the found membership
        return true;
      }

      return false;
    },

    checkIndvTeamRegistered(product, teamId) {
      const foundIndvTeamRegistration = this.memberMembership
        .find((m) => _.get(m, 'regoEntity.products._id') === product._id
          && m.expired !== true
          && m.team._id === teamId);
      if (foundIndvTeamRegistration) {
        return true;
      }
      return false;
    },
    isEligible(product) {
      if (this.selectedMember) {
        // find the registration product based on the productid
        // const foundProduct = this.localRegistration.product.find((p) => p._id === productId);
        if (product.type !== 'family' && product.type !== 'team') {
          if (product) {
            // check gender of the product  and calculate the age of the member and conpare with the age range of the product
            const {
              gender, ageFrom, ageTo,
            } = product;
            const { dob, gender: memberGender } = this.selectedMember.profile;
            const age = this.calculateAge(dob, _.get(this.localRegistration, 'meta.ageAsOfDate'), _.get(this.localRegistration, 'meta.ageCalculationType'));
            if (ageFrom <= age
              && ageTo >= age
              && (memberGender === gender
                || gender === 'All'
                || !gender
                || (gender && product.type === 'team')
                || (gender === 'Other'
                  && (memberGender !== 'Male'
                    && memberGender !== 'Female'))
              )) {
              return true;
            }
            return false;
          }
        } else {
          return true;
        }
      }
      return true;
    },
    isEligibleForBulkRego(member) {
      const { dob, gender: memberGender } = member.profile;
      const age = this.calculateAge(dob, _.get(this.localRegistration, 'meta.ageAsOfDate'), _.get(this.localRegistration, 'meta.ageCalculationType'));
      const { ageFrom, ageTo, gender } = this.selectedProductArr[0];
      return ageFrom <= age && ageTo >= age && (memberGender === gender || gender === 'All' || !gender || (gender === 'Other' && (memberGender !== 'Male' && memberGender !== 'Female')));
    },
    handleSelectionChange(val) {
      this.selectedMembers = val.map((member) => member._id);
    },
    submitBulkRegistration() {
      if (this.selectedMembers.length === 0) {
        this.$message.error('Please select at least one member.');
        return;
      }
      const selectedMemberDetails = this.selectedMembers.map((memberId) => {
        const member = this.members.find((m) => m._id === memberId);
        return member;
      });
      this.$store.commit('cart/setSelectedBulkMembers', selectedMemberDetails);
      const regoObj = this.generateRegoObject(this.selectedProductArr);
      regoObj.memberIds = this.selectedMembers;
      if (this.selectedTeamForBulkRego) {
        regoObj.selectedTeam = this.selectedTeamForBulkRego._id;
      }
      regoObj.isBulk = true;
      this.$emit('register', regoObj);
      this.bulkRegoDialog = false;
    },
    isProductRegoActive(product) {
      return product.isActive;
    },
    getRegoLogo(rego) {
      const regoLogo = _.get(rego, 'meta.imgUrl', this.defaultRegoLogo);
      return `${regoLogo}?v=${moment().valueOf()}`;
    },
    isExpired(date) {
      if (date) {
        if (date >= +moment()) return false;
        return true;
      }
      return false;
    },
    async handleTeamSelected(e, productId) {
      const filteredProducts = this.localRegistration.product.filter((p) => p._id === productId);
      const [product] = filteredProducts;
      const isEligible = this.isEligible(product);
      const fullSlot = this.checkFullIndvTeamSlot(product, e._id);
      const isRegistered = this.checkIndvTeamRegistered(product, e._id);
      const isWaitlistOpen = this.checkIsWaitlistOpenIndvToTeam(product, e._id);

      if (isRegistered) {
        this.$notify({
          title: 'Already Registered',
          message: 'You are already registered for this team.',
          type: 'success',
          duration: 5000,
        });
        return;
      }
      if (!isEligible) {
        this.$notify({
          title: 'Ineligible',
          message: 'You are not eligible to register for this team.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (isWaitlistOpen) {
        this.$notify({
          title: 'Join Waitlist',
          message: 'You are joining the waitlist for this team.',
          type: 'success',
          duration: 5000,
        });
        this.joinWaitlist(productId);
        return;
      }
      if (fullSlot) {
        this.$notify({
          title: 'Full',
          message: 'This team is full.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      const teamId = e._id;
      const showAlert = () => {
        if (this.localRegistration.requiresApproval) {
          if (this.localRegistration.newMembersOnly) {
            let foundMembership;
            if (this.localRegistration.newMembersThisEntityOnly) {
              // Check for memberships from the same parent entity
              foundMembership = this.memberMembership.find((m) => {
                if (m.entityType === 'membership' && m.membership && m.membership[0]) {
                  const membership = m.membership[0];
                  return membership.entityType === this.localRegistration.entityType
                         && membership.entityId === this.localRegistration.entityId;
                }
                return false;
              });
            } else {
              // Original logic: check for any active membership
              foundMembership = this.memberMembership.find((m) => m.entityType === 'membership');
            }
            console.log('foundMembership', foundMembership);
            if (foundMembership) {
              return false;
            }
          }
          // Check if member is renewing - don't show alert for renewals
          const isRenewing = this.isRenewable(filteredProducts[0]);
          if (isRenewing) {
            return false;
          }
          return true;
        }
        return false;
      };

      if (showAlert()) {
        try {
          await this.$confirm(
            `<div style="text-align: left; line-height: 1.5;">
              <p style="margin-bottom: 10px;">Dear ${this.selectedMember.profile.firstName},</p>
              <p style="margin-bottom: 10px;">This registration is not considered 'Approved' until your administrator has 'Approved' this registration.</p>
              <p style="margin-bottom: 10px;">Once an approval or decline has occurred you will be notified via email.</p>
              <p style="margin-bottom: 0;">You can also view the status of this registration via registration history in the portal.</p>
            </div>`,
            'Registration Approval Required',
            {
              confirmButtonText: 'Continue',
              cancelButtonText: 'Cancel',
              dangerouslyUseHTMLString: true,
            }
          );
        } catch (error) {
          // User clicked cancel
          return;
        }
      }

      // Check if team code is required
      if (product.requireTeamCode) {
        console.log('query params', this.$route.query);
        const routeTeamCode = parseInt(this.$route.query.teamCode, 10);
        const teamCode = _.get(e, 'meta[0].teamCode');
        console.log('routeTeamCode', routeTeamCode);
        console.log('teamCode', teamCode);

        if (!routeTeamCode || routeTeamCode !== teamCode) {
          this.selectedTeamForPasscode = e;
          this.selectedProductForPasscode = product;
          this.teamPasscodeDialog = true;
          this.teamPasscodeInput = '';
          return;
        }
      }

      // Check if bulk registration is allowed
      if (product.bulkRegoAllowed) {
        this.$confirm('Do you want to register multiple members to this team?', 'Confirmation', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          // If user confirms, open bulk registration dialog
          this.bulkRegoDialog = true;
          this.$emit('inOpenBulkRego', true);
          this.selectedProductArr = filteredProducts;
          [this.selectedProduct] = filteredProducts;
          this.selectedTeamForBulkRego = e;
        }).catch(() => {
          // If user cancels, proceed with single member registration
          this.registerSingleMemberToTeam(filteredProducts, teamId);
        });
      } else {
        // If bulk registration is not allowed, proceed with single member registration
        this.registerSingleMemberToTeam(filteredProducts, teamId);
      }
    },
    registerSingleMemberToTeam(filteredProducts, teamId) {
      const regoObj = this.generateRegoObject(filteredProducts, teamId);

      this.$emit('register', regoObj);
    },
    handleTeamSelectedMethod(row, product) {
      const isEligible = this.isEligible(product);
      const fullSlot = this.checkFullIndvTeamSlot(product, row._id);
      const isRegistered = this.checkIndvTeamRegistered(product, row._id);

      if (isRegistered) {
        this.$notify({
          title: 'Already Registered',
          message: 'You are already registered for this team.',
          type: 'success',
          duration: 5000,
        });
        return;
      }
      if (!isEligible) {
        this.$notify({
          title: 'Ineligible',
          message: 'You are not eligible to register for this team.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (fullSlot) {
        this.$notify({
          title: 'Full',
          message: 'This team is full.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }

      const filteredProducts = this.localRegistration.product.filter((p) => p._id === this.tempProduct._id);

      // Check if team code is required
      if (product.requireTeamCode) {
        const routeTeamCode = parseInt(this.$route.query.teamCode, 10);
        const teamCode = _.get(row, 'meta[0].teamCode');

        if (!routeTeamCode || routeTeamCode !== teamCode) {
          this.selectedTeamForPasscode = row;
          this.selectedProductForPasscode = product;
          this.teamPasscodeDialog = true;
          this.teamPasscodeInput = '';
          return;
        }
      }

      // Check if bulk registration is allowed
      if (product.bulkRegoAllowed) {
        this.$confirm('Do you want to register multiple members to this team?', 'Confirmation', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          // If user confirms, open bulk registration dialog
          this.bulkRegoDialog = true;
          this.selectedProductArr = filteredProducts;
          this.selectedTeamForBulkRego = row;
        }).catch(() => {
          // If user cancels, proceed with single member registration
          this.registerSingleMemberToTeam(filteredProducts, row._id);
        });
      } else {
        // If bulk registration is not allowed, proceed with single member registration
        this.registerSingleMemberToTeam(filteredProducts, row._id);
      }

      this.showTeamSelectIndvToTeam = false;
    },
    handleEntitySelected(selected) {
      const { entityId, productId, entityType } = selected;
      this.selectedEntity = selected;
      const filteredProducts = this.localRegistration.product.filter((p) => p._id === productId);
      if (entityType === 'team') {
        const regoObj = this.generateRegoObject(filteredProducts, null, entityId);
        this.$emit('register', regoObj);
      } else {
        this.searchEntity(entityType);
        this.showEntitySelect = true;
      }
    },
    createNewEntity() {
      const { entityId, productId } = this.selectedEntity;
      const filteredProducts = this.localRegistration.product.filter((p) => p._id === productId);
      const regoObj = this.generateRegoObject(filteredProducts, null, entityId);
      this.$emit('register', regoObj);
    },
    generateRegoObject(filteredProducts, teamId, OrgId, team, customRego, entity) {
      const {
        acceptActiveKids, description, endDate, entityId, entityType, isRegoOpen, meta, registrationType, name, discounts,
        multipleRegoDiscounts, orgtree, regoEndDate, regoStartDate, saleableItems, additionalQs, startDate, teams, _id, isClubMembership, isRenewable, renewalAdditionalQs, renewalSaleableItems, useDuration,
        durationYear, durationMonth, durationDay, isTCRequired, isTCPrefilled, requiresApproval, newMembersOnly
      } = customRego || this.localRegistration;
      const filteredAdditionalQs = additionalQs.filter((q) => {
        if (filteredProducts[0].type === 'team' || filteredProducts[0].type === 'entity') {
          return _.includes(q.productTypes, filteredProducts[0].type) && q.isActive;
        }
        return _.includes(q.productTypes, filteredProducts[0].type) && q.isActive && _.includes(q.memberTypes, filteredProducts[0].memberType);
      });
      const filteredSaleableItems = saleableItems.filter((si) => {
        if (filteredProducts[0].type === 'team' || filteredProducts[0].type === 'entity') {
          return _.includes(si.productTypes, filteredProducts[0].type) && si.isActive;
        }
        return _.includes(si.productTypes, filteredProducts[0].type) && si.isActive && _.includes(si.memberTypes, filteredProducts[0].memberType);
      });

      const regoObj = {
        acceptActiveKids,
        name,
        memberId: this.selectedMember._id,
        registrationType,
        isClubMembership,
        isRenewable,
        description,
        endDate,
        entityId,
        entityType,
        isRegoOpen,
        meta,
        entityLogo: _.get(meta, 'imgUrl', this.defaultRegoLogo),
        discounts,
        multipleRegoDiscounts,
        orgtree,
        products: filteredProducts,
        regoEndDate,
        regoStartDate,
        // filter saleable Items with matching product type and memberType and isActive
        saleableItems: filteredSaleableItems,
        additionalQs: filteredAdditionalQs,
        startDate,
        teams,
        _id,
        productType: filteredProducts[0].type,
        tags: filteredProducts[0].tags,
        useDuration,
        durationYear,
        durationMonth,
        durationDay,
        isTCRequired,
        isTCPrefilled,
        requiresApproval,
        newMembersOnly,
        renewalAdditionalQs,
        renewalSaleableItems
      };
      if (filteredProducts[0].type !== 'team' || filteredProducts[0].type !== 'entity') {
        _.assign(regoObj, { memberType: filteredProducts[0].memberType });
      }
      if (teamId) {
        _.assign(regoObj, { selectedTeam: teamId });
      }
      if (OrgId) {
        _.assign(regoObj, { selectedEntity: OrgId });
      }
      if (team && team._id) {
        _.assign(regoObj, { team });
      }
      if (entity && entity._id) {
        _.assign(regoObj, { entity });
      }
      if (filteredProducts[0].renewingProduct) {
        _.assign(regoObj, { isRenewingProduct: true, renewFrom: filteredProducts[0].renewFrom });
      }
      this.$store.commit('cart/setPendingRegistration', this.localRegistration._id);
      return regoObj;
    },
    filteredTeams(product) {
      const { teams } = this.localRegistration;
      const pendingRegos = this.$store.getters['cart/registrations'];
      const numberOfSameProduct = pendingRegos.filter((r) => r.product._id === product._id).length;

      if (teams && teams.length) {
        const teamProduct = (this.localRegistration.products || this.localRegistration.product || []).find((p) => {
          if (p.type !== 'team') return false;

          if (p.tags && p.tags.length && product.tags && product.tags.length) {
            // If both products have tags, match based on tags only
            return _.isEqual(p.tags.map((t) => t._id).sort(), product.tags.map((t) => t._id).sort());
          }
          console.log({
            p: p.gender,
            product: product.gender
          });

          // First prioritize exact gender match with age range
          return p.ageFrom === product.ageFrom && p.ageTo === product.ageTo && p.gender === product.gender;
        });

        // If no exact match found, try with gender 'All'
        const allGenderTeamProduct = !teamProduct && (this.localRegistration.products || []).find((p) => {
          if (p.type !== 'team') return false;

          // Match age range with gender 'All' or no gender
          return p.ageFrom === product.ageFrom && p.ageTo === product.ageTo && (p.gender === 'All' || !p.gender);
        });

        // Use the exact match if found, otherwise use the 'All' gender match
        const finalTeamProduct = teamProduct || allGenderTeamProduct;

        if (!finalTeamProduct) {
          return [];
        }
        let filteredTeams = teams.filter((team) => {
          if (+process.env.VUE_APP_NATIONAL_ID === 7) {
            return true;
          }

          let isEligible = false;

          if (team.productMeta) {
            isEligible = team.productMeta.teamProductId === finalTeamProduct._id;
          } else if (team.meta && team.meta[0]) {
            const teamMeta = team.meta[0] || team.meta;
            isEligible = teamMeta.ageFrom === finalTeamProduct.ageFrom
              && teamMeta.ageTo === finalTeamProduct.ageTo
              && (!finalTeamProduct.gender || finalTeamProduct.gender === 'All' || teamMeta.gender === finalTeamProduct.gender);
          }

          if (team.tags && team.tags.length && finalTeamProduct.tags) {
            const teamTags = team.tags.map((tag) => tag._id).sort();
            const productTags = finalTeamProduct.tags.map((tag) => tag._id).sort();
            isEligible = isEligible || _.isEqual(teamTags, productTags);
          }

          return isEligible;
        });

        // Apply search filter
        if (this.teamKeyword) {
          const keyword = this.teamKeyword.toLowerCase();
          filteredTeams = filteredTeams.filter((team) => team.name.toLowerCase().includes(keyword)
            || (team.meta && team.meta[0] && team.meta[0].contact && team.meta[0].contact.name.toLowerCase().includes(keyword)));
        }

        _.forEach(filteredTeams, (team) => {
          const registrationCounts = _.get(this, 'localRegistration.registrationCounts', {});
          const maxNoIndvTeam = _.get(this, 'localRegistration.product.maxNoIndvTeam');

          // Find team-specific count for this product from registrationCounts
          const teamRegData = _.get(registrationCounts, 'indvToTeamPerProduct', [])
            .find((item) => item.teamId === team._id && item.productId === product._id);

          const teamRegCount = teamRegData ? teamRegData.count : 0;

          if (maxNoIndvTeam !== 0 && teamRegCount + numberOfSameProduct >= maxNoIndvTeam) {
            _.assign(team, { isFull: true });
          }
        });

        if (this.teamId && this.teamId !== '' && filteredTeams.length) {
          const id = parseInt(this.teamId);
          const team = filteredTeams.find((t) => t._id === id);
          if (team) {
            return [team];
          }
        }

        return filteredTeams;
      }

      return [];
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    dateFormatter(timestamp) {
      // format dd/mmm/yyyy
      return moment(timestamp).tz('Australia/Sydney').format('DD MMM YYYY');
    },
    priceFormatted(price) {
      // price currently in cents
      return `$${(price / 100).toFixed(2)}`;
    },
    tagsFormatted(tags) {
      // tags is an array containing objects
      return tags.map((tag) => tag.name).join(', ');
    },
    typeFormatter(type) {
      if (type === 'indv') return 'Become a member';
      if (type === 'indv-to-team') return 'Join a team';
      if (type === 'team') return 'Register a team';
      return '';
    },
    getAvailableMembers(fmsProduct, product) {
      const members = _.filter(this.members, (member) => {
        const endOfYear = this.$store.getters['national/endOfYear'];
        const memberAge = calculateMemberAge(member.profile.dob, endOfYear);

        return (memberAge >= fmsProduct.ageFrom && memberAge <= fmsProduct.ageTo)
          && (fmsProduct.gender === member.profile.gender
            || fmsProduct.gender === 'All'
            || (fmsProduct.gender === 'Other' && (member.profile.gender !== 'Male' || member.profile.gender !== 'Female')));
      });

      // required memberships
      const requiredMSProducts = _.map(product.membershipProductsRequired, (ms) => ms.products._id);

      const mappedMembers = [];

      if (requiredMSProducts && requiredMSProducts.length) {
        _.forEach(members, (member) => {
          const mappedProductId = _.map(member.registration, (rego) => rego.productId);
          const intersection = _.intersection(requiredMSProducts, mappedProductId);
          if (intersection.length === requiredMSProducts.length) mappedMembers.push(member);
        });
      }
      return _.get(this, 'selectedRego.products[0].isMembershipRequired') ? mappedMembers : members;
    },
    checkFamily(product) {
      this.disabledMemberSelect = false;
      this.familyMSList = product.familyMS;
      _.forEach(this.familyMSList, (fmsProduct) => {
        // eslint-disable-next-line no-param-reassign
        fmsProduct.availableMembers = this.getAvailableMembers(fmsProduct, product);
      });
      const isRenewable = this.isRenewable(product);
      if (isRenewable) {
        const found = this.memberMembership
          .find((m) => _.get(m, 'regoEntity.products._id') === product._id && m.regoEntity.isRenewable);
        const { memberIds } = found.regoEntity;

        // Helper function to check eligibility
        const isEligibleForProduct = (member, fmsProduct) => {
          const age = this.calculateAge(member.profile.dob, _.get(this.localRegistration, 'meta.ageAsOfDate'), _.get(this.localRegistration, 'meta.ageCalculationType'));
          const isAgeEligible = age >= fmsProduct.ageFrom && age <= fmsProduct.ageTo;
          const isGenderEligible = fmsProduct.gender === member.profile.gender
            || fmsProduct.gender === 'All'
            || !fmsProduct.gender
            || (fmsProduct.gender === 'Other'
              && (member.profile.gender !== 'Male' && member.profile.gender !== 'Female'));

          return isAgeEligible && isGenderEligible;
        };

        const memberDetails = this.members.filter((m) => memberIds.includes(m._id));
        const eligibilityMap = new Map();

        // Build eligibility map
        memberDetails.forEach((member) => {
          const eligibleProducts = this.familyMSList.map((fmsProduct, index) => ({
            index,
            isEligible: isEligibleForProduct(member, fmsProduct)
          }))
            .filter((p) => p.isEligible)
            .map((p) => p.index);

          eligibilityMap.set(member._id, eligibleProducts);
        });

        const assignedMemberIds = new Set();
        const assignedProducts = new Set();

        // First pass: assign members who are only eligible for one product
        this.familyMSList.forEach((fmsProduct, productIndex) => {
          const exclusiveMembers = Array.from(eligibilityMap.entries())
            .filter(([memberId, eligibleProducts]) => !assignedMemberIds.has(memberId)
              && eligibleProducts.length === 1
              && eligibleProducts[0] === productIndex);

          if (exclusiveMembers.length > 0) {
            const [memberId] = exclusiveMembers[0];
            // eslint-disable-next-line no-param-reassign
            fmsProduct.memberId = memberId;
            assignedMemberIds.add(memberId);
            assignedProducts.add(productIndex);
          }
        });

        // Second pass: assign remaining products based on available members with fewest options
        this.familyMSList.forEach((fmsProduct, productIndex) => {
          if (assignedProducts.has(productIndex)) return;

          const eligibleMembers = Array.from(eligibilityMap.entries())
            .filter(([memberId, eligibleProducts]) => !assignedMemberIds.has(memberId)
              && eligibleProducts.includes(productIndex))
            .sort((a, b) => a[1].length - b[1].length);

          if (eligibleMembers.length > 0) {
            const [memberId] = eligibleMembers[0];
            // eslint-disable-next-line no-param-reassign
            fmsProduct.memberId = memberId;
            assignedMemberIds.add(memberId);
            assignedProducts.add(productIndex);
          } else {
            // eslint-disable-next-line no-param-reassign
            fmsProduct.memberId = undefined;
            console.warn(`No eligible member found for family product at index ${productIndex}`);
          }
        });

        this.disabledMemberSelect = true;
      }
      this.familyMSDialog = true;
    },
    prepareFamilyRegistration(product) {
      // Set the selected product for later use
      this.selectedProductArr = [product];
      // Prepare family MS list without showing dialog
      this.disabledMemberSelect = false;
      this.familyMSList = product.familyMS;
      _.forEach(this.familyMSList, (fmsProduct) => {
        // eslint-disable-next-line no-param-reassign
        fmsProduct.availableMembers = this.getAvailableMembers(fmsProduct, product);
      });
      const isRenewable = this.isRenewable(product);
      if (isRenewable) {
        const found = this.memberMembership
          .find((m) => _.get(m, 'regoEntity.products._id') === product._id && m.regoEntity.isRenewable);
        const { memberIds } = found.regoEntity;

        // Helper function to check eligibility
        const isEligibleForProduct = (member, fmsProduct) => {
          const age = this.calculateAge(member.profile.dob, _.get(this.localRegistration, 'meta.ageAsOfDate'), _.get(this.localRegistration, 'meta.ageCalculationType'));
          const isAgeEligible = age >= fmsProduct.ageFrom && age <= fmsProduct.ageTo;
          const isGenderEligible = fmsProduct.gender === member.profile.gender
            || fmsProduct.gender === 'All'
            || !fmsProduct.gender
            || (fmsProduct.gender === 'Other'
              && (member.profile.gender !== 'Male' && member.profile.gender !== 'Female'));

          return isAgeEligible && isGenderEligible;
        };

        const memberDetails = this.members.filter((m) => memberIds.includes(m._id));
        const eligibilityMap = new Map();

        // Build eligibility map
        memberDetails.forEach((member) => {
          const eligibleProducts = this.familyMSList.map((fmsProduct, index) => ({
            index,
            isEligible: isEligibleForProduct(member, fmsProduct)
          }))
            .filter((p) => p.isEligible)
            .map((p) => p.index);

          eligibilityMap.set(member._id, eligibleProducts);
        });

        const assignedMemberIds = new Set();
        const assignedProducts = new Set();

        // First pass: assign members who are only eligible for one product
        this.familyMSList.forEach((fmsProduct, productIndex) => {
          const exclusiveMembers = Array.from(eligibilityMap.entries())
            .filter(([memberId, eligibleProducts]) => !assignedMemberIds.has(memberId)
              && eligibleProducts.length === 1
              && eligibleProducts[0] === productIndex);

          if (exclusiveMembers.length > 0) {
            const [memberId] = exclusiveMembers[0];
            // eslint-disable-next-line no-param-reassign
            fmsProduct.memberId = memberId;
            assignedMemberIds.add(memberId);
            assignedProducts.add(productIndex);
          }
        });

        // Second pass: assign remaining products based on available members with fewest options
        this.familyMSList.forEach((fmsProduct, productIndex) => {
          if (assignedProducts.has(productIndex)) return;

          const eligibleMembers = Array.from(eligibilityMap.entries())
            .filter(([memberId, eligibleProducts]) => !assignedMemberIds.has(memberId)
              && eligibleProducts.includes(productIndex))
            .sort((a, b) => a[1].length - b[1].length);

          if (eligibleMembers.length > 0) {
            const [memberId] = eligibleMembers[0];
            // eslint-disable-next-line no-param-reassign
            fmsProduct.memberId = memberId;
            assignedMemberIds.add(memberId);
            assignedProducts.add(productIndex);
          } else {
            // eslint-disable-next-line no-param-reassign
            fmsProduct.memberId = undefined;
            console.warn(`No eligible member found for family product at index ${productIndex}`);
          }
        });

        this.disabledMemberSelect = true;
      }
      // Don't show dialog, popover will handle it
    },
    // sample code for family registration
    // initRegoFamily(familyProduct) {
    //   const mappedFamilyRego = _.map(familyProduct, (fp) => ({
    //     ...this.selectedRego,
    //     ...fp,
    //     _id: this.selectedRego._id,
    //     gender: fp.gender,
    //     ageFrom: fp.ageFrom,
    //     ageTo: fp.ageTo,
    //     memberType: fp.memberType,
    //     productId: _.get(this, 'selectedRego.products[0]._id'),
    //     products: [
    //       {
    //         ...this.selectedRego.products[0],
    //         gender: fp.gender,
    //         ageFrom: fp.ageFrom,
    //         ageTo: fp.ageTo,
    //         memberType: fp.memberType,
    //         familyProductId: fp._id,
    //       }
    //     ]
    //   }));

    //   this.selectedRego.familyRego = mappedFamilyRego;

    //   this.selectedFamilyMember = true;
    //   this.register(this.selectedRego);
    // },

    initRegoFamily(familyProducts) {
      const product = this.selectedProductArr[0];
      if (this.isRenewable(product)) {
        const found = this.memberMembership
          .find((m) => _.get(m, 'regoEntity.products._id') === product._id && m.regoEntity.isRenewable);
        _.assign(this.selectedProductArr[0], {
          renewingProduct: true,
          renewFrom: found._id
        });
      }
      const rego = this.generateRegoObject(this.selectedProductArr);
      const mappedFamilyRego = _.map(familyProducts, (fp) => ({
        ...rego,
        ...fp,
        _id: rego._id,
        gender: fp.gender,
        ageFrom: fp.ageFrom,
        ageTo: fp.ageTo,
        memberType: fp.memberType,
        productId: _.get(this, 'selectedProductArr[0]._id'),
        products: [
          {
            ...this.selectedProductArr[0],
            gender: fp.gender,
            ageFrom: fp.ageFrom,
            ageTo: fp.ageTo,
            memberType: fp.memberType,
            familyProductId: fp._id,
          }
        ]
      }));
      _.assign(rego, { familyRego: mappedFamilyRego });
      this.selectedFamilyMember = true;
      this.$emit('register', rego);
    },
    getRenewalDuration() {
      const { durationYear, durationMonth, durationDay } = this.localRegistration;
      if (durationYear > 0) return `${durationYear} year${durationYear > 1 ? 's' : ''}`;
      if (durationMonth > 0) return `${durationMonth} month${durationMonth > 1 ? 's' : ''}`;
      if (durationDay > 0) return `${durationDay} day${durationDay > 1 ? 's' : ''}`;
      return '';
    },
    checkPendingRegistrationsRequiringApproval(product) {
      const pendingRegos = this.$store.getters['cart/registrations'];

      if (product.membershipProductsRequired && product.membershipProductsRequired.length > 0) {
        const pendingMembershipsRequiringApproval = [];

        product.membershipProductsRequired.forEach((requiredProduct) => {
          const matchingRego = pendingRegos.find((rego) => rego.product._id === requiredProduct.products._id
            && rego.product.type === requiredProduct.products.type
            && rego.product.memberType === requiredProduct.products.memberType
            && rego.memberId === this.selectedMember._id
            && rego.requiresApproval === true);

          if (matchingRego) {
            pendingMembershipsRequiringApproval.push(matchingRego.product.name);
          }
        });

        return pendingMembershipsRequiringApproval.length > 0 ? pendingMembershipsRequiringApproval : false;
      }

      return false;
    },
    checkPendingMembershipApprovals(product) {
      if (!product.membershipProductsRequired || product.membershipProductsRequired.length === 0) {
        return false;
      }

      const pendingMembershipsAwaitingApproval = [];

      product.membershipProductsRequired.forEach((requiredProduct) => {
        // Check if user has a pending membership registration awaiting approval
        const foundPendingMembership = this.memberMembership.find((m) => {
          const isMatchingProduct = _.get(m, 'regoEntity.products._id') === requiredProduct.products._id
            && m.productType === requiredProduct.products.type
            && m.memberType === requiredProduct.products.memberType
            && m.expired !== true;

          const isPendingApproval = m.approvalStatus === 'pending';

          return isMatchingProduct && isPendingApproval;
        });

        if (foundPendingMembership) {
          pendingMembershipsAwaitingApproval.push(requiredProduct.products.name || foundPendingMembership.regoEntity.products.name);
        }
      });

      return pendingMembershipsAwaitingApproval.length > 0 ? pendingMembershipsAwaitingApproval : false;
    },
    async register(productId, event = null) {
      const isWaitlistOpen = this.checkIsWaitlistOpen(productId);
      if (isWaitlistOpen) {
        this.joinWaitlist(productId);
        return;
      }
      const filteredProducts = this.localRegistration.product.filter((p) => p._id === productId);
      this.selectedProductArr = filteredProducts;

      const showAlert = () => {
        if (this.localRegistration.requiresApproval) {
          if (this.localRegistration.newMembersOnly) {
            console.log('newMembersOnly', this.localRegistration);
            let foundMembership;
            if (this.localRegistration.newMembersThisEntityOnly) {
              // Check for memberships from the same parent entity
              foundMembership = this.memberMembership.find((m) => {
                if (m.entityType === 'membership' && m.membership && m.membership[0]) {
                  const membership = m.membership[0];
                  return membership.entityType === this.localRegistration.entityType
                         && membership.entityId === this.localRegistration.entityId;
                }
                return false;
              });
            } else {
              // Original logic: check for any active membership
              foundMembership = this.memberMembership.find((m) => m.entityType === 'membership');
            }
            console.log('foundMembership', foundMembership, this.memberMembership, this.localRegistration);
            if (foundMembership) {
              return false;
            }
          }
          // Check if member is renewing - don't show alert for renewals
          const isRenewing = this.isRenewable(filteredProducts[0]);
          if (isRenewing) {
            return false;
          }
          return true;
        }
        return false;
      };

      if (showAlert()) {
        try {
          await this.$confirm(
            `<div style="text-align: left; line-height: 1.5;">
              <p style="margin-bottom: 10px;">Dear ${this.selectedMember.profile.firstName},</p>
              <p style="margin-bottom: 10px;">This registration is not considered 'Approved' until your administrator has 'Approved' this registration.</p>
              <p style="margin-bottom: 10px;">Once an approval or decline has occurred you will be notified via email.</p>
              <p style="margin-bottom: 0;">You can also view the status of this registration via registration history in the portal.</p>
            </div>`,
            'Registration Approval Required',
            {
              confirmButtonText: 'Continue',
              cancelButtonText: 'Cancel',
              dangerouslyUseHTMLString: true,
            }
          );
        } catch (error) {
          // User clicked cancel
          return;
        }
      }

      if (this.isRenewable(filteredProducts[0])) {
        try {
          await this.$confirm(`This registration is renewable. Your membership will be renewed for ${this.getRenewalDuration()}. Do you want to continue?`, 'Confirmation', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning'
          });
          // Continue with registration after confirmation
        } catch {
          return; // User clicked No or closed dialog
        }
      }

      // find product in localRegistration
      const product = this.localRegistration.product.find((p) => p._id === productId);

      // Check if there are pending registrations requiring approval
      const pendingMemberships = this.checkPendingRegistrationsRequiringApproval(product);
      if (pendingMemberships) {
        const membershipList = pendingMemberships.map((name) => `• ${name}`).join('<br>');
        try {
          await this.$confirm(
            `<div style="text-align: left; line-height: 1.5;">
              <p style="margin-bottom: 10px;">This product requires a membership that is currently in your cart and pending approval:</p>
              <div style="margin: 15px 0; padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
                ${membershipList}
              </div>
              <p style="margin-bottom: 10px;">These memberships need to be completed and approved first before you can register for this product.</p>
              <p style="margin-bottom: 0;">Please complete those registrations or contact your administrator for assistance.</p>
            </div>`,
            'Membership Approval Required',
            {
              confirmButtonText: 'OK',
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }
          );
        } catch (error) {
          // User closed the dialog
        }
        return;
      }

      // Check if membership is required and if there are pending approvals
      if (this.isMembershipRequired(product)) {
        const pendingMembershipApprovals = this.checkPendingMembershipApprovals(product);
        if (pendingMembershipApprovals && pendingMembershipApprovals.length > 0) {
          const membershipList = pendingMembershipApprovals.map((name) => `• ${name}`).join('<br>');
          try {
            await this.$confirm(
              `<div style="text-align: left; line-height: 1.5;">
                <p style="margin-bottom: 10px;">This product requires a membership that is currently pending approval:</p>
                <div style="margin: 15px 0; padding: 10px; background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px;">
                  ${membershipList}
                </div>
                <p style="margin-bottom: 10px;">These memberships are awaiting approval from your administrator before you can register for this product.</p>
                <p style="margin-bottom: 0;">You will be notified via email once your membership is approved.</p>
              </div>`,
              'Membership Approval Pending',
              {
                confirmButtonText: 'OK',
                showCancelButton: false,
                dangerouslyUseHTMLString: true,
                type: 'warning'
              }
            );
          } catch (error) {
            // User closed the dialog
          }
          return;
        }
      }

      // Family membership is now handled via popover
      if (product.familyMS && product.familyMS.length && !this.selectedFamilyMember) {
        // No longer need to call checkFamily here as it's handled by popover
        return;
      }
      // filter out other products from the product array
      const isPayAfter = this.checkPayAfter(productId);
      if (isPayAfter) {
        const rego = this.memberMembership
          .find((m) => _.get(m, 'regoEntity.products._id') === productId
            && m.expired !== true);
        this.$router.push({ name: 'partial-payment', params: { id: rego._id } });
        return;
      }
      // if (this.isRenewable(product)) {
      //   const found = this.memberMembership
      //     .find((m) => _.get(m, 'regoEntity.products._id') === product._id && m.regoEntity.isRenewable);
      //   this.dialogValue = {
      //     filtersVisible: true,
      //     entityType: 'indv',
      //     registration: found,
      //     regoDetails: found,
      //     member: this.selectedMember,
      //   };
      //   this.renewingProduct = found;
      //   // this.showRenewPayment = true;
      //   const regoObj = this.generateRegoObject(this.renewingProduct);
      //   this.$emit('register', regoObj);
      //   return;
      // }

      if (filteredProducts.length) {
        [this.selectedProduct] = filteredProducts;
        if (product.bulkRegoAllowed) {
          try {
            await this.$confirm('Do you want to register multiple members at once?', 'Confirmation', {
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              type: 'warning'
            });
            this.bulkRegoDialog = true;
            return;
          } catch (e) {
            // User canceled the confirmation dialog
          }
        }
        if (_.get(filteredProducts, '[0].isPrivate')) {
          if (this.privateProps.password) {
            try {
              const res = await this.$http.post('/assemble/api/v1/portal/registrations/product/password-decrypt', {
                productId: filteredProducts[0]._id,
                password: this.privateProps.password
              });
              this.product.password = res.data.data;
              const auth = await this.$http.post('/assemble/api/v1/portal/registrations/product/auth', {
                password: this.product.password,
                productId: filteredProducts[0]._id
              });
              if (auth.data.data) {
                const regoObj = this.generateRegoObject(filteredProducts);
                this.$emit('register', regoObj);
              }
            } catch (e) {
              datadogRum.addError(e);
              this.showPasswordPopover(event);
            }
          }
          this.showPasswordPopover(event);
        } else if (filteredProducts[0].type === 'team') {
          this.searchTeam();
          this.showTeamSelect = true;
        } else {
          if (this.isRenewable(product)) {
            const found = this.memberMembership
              .find((m) => _.get(m, 'regoEntity.products._id') === product._id);
            _.assign(filteredProducts[0], {
              renewingProduct: true,
              renewFrom: found._id
            });
          }

          const regoObj = this.generateRegoObject(filteredProducts);
          this.$emit('register', regoObj);
        }
      }
      // replace product array with filteredProducts
      // const regoObj = this.generateRegoObject(filteredProducts);
      // this.$emit('register', regoObj);
    },
    handleEventRegsiterClicked() {
      // expand all products
      this.expandAllProducts();
      // emit event to parent
      this.$emit('event-register-clicked', this.localRegistration._id);
    },
    handleShowMoreDetails(productId) {
      const productIndex = this.localRegistration.product.findIndex((p) => p._id === productId);
      this.localRegistration.product[productIndex].showMoreDetails = !this.localRegistration.product[productIndex].showMoreDetails;
      this.key += 1;
    },
    toggleBodyScroll(disable) {
      this.$emit('inOpenBulkRego', disable);
    },
    // Add new method for filtering selected members
    getFilteredMembers(row) {
      const selectedMemberIds = this.familyMSList
        .filter((item) => item.memberId && item !== row) // Exclude current row
        .map((item) => item.memberId);

      return row.availableMembers.filter((member) => !selectedMemberIds.includes(member._id));
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      // eslint-disable-next-line no-param-reassign
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  watch: {
    bulkRegoDialog(newVal) {
      this.toggleBodyScroll(newVal);
    },
  },
  created() {
    // Listen for changes in event sticky header visibility
    this.$root.$on('eventStickyHeaderChanged', this.updateStickyHeaderPositions);
    // Listen for expand/collapse changes from drawer
    this.$root.$on('drawerExpandAllChanged', this.handleDrawerExpandAllChanged);
  },

};
</script>

<style lang="scss" scoped>
.no-scroll {
  overflow: hidden !important;
}

.no-scroll-dialog {
  max-height: 90vh;
  overflow-y: auto;
}

::v-deep .el-table .el-table__cell {
  cursor: pointer !important;
}

::v-deep .el-dialog__body {
  align-items: normal;
}

em {
  // font-family: 'BrownStd-Light';
  font-style: italic;
}

strong {
  font-weight: 600 !important;
  color: #152934;
}

strong em,
em strong {
  font-weight: 600;
  font-style: italic;
}

.is-hidden {
  display: none;
}

.overview-grid {
  display: grid;
  grid-template-columns: 25rem 1fr;

  p {
    margin-left: 1rem;
    letter-spacing: 0.01rem;
  }
}

::v-deep .el-dropdown-menu--medium .el-dropdown-menu__item {
  width: 100px !important;
}

::v-deep .el-collapse-item .el-collapse-item__header {
  background: $secondaryLight;
  padding: 0 1rem;
  position: sticky;
  top: 1rem;
  z-index: 997;
  border-radius: 8px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &.is-sticky {
    margin: 0 !important;
    border-radius: 0 !important;
    top: 0 !important;
  }

  &::after {
    // highlight line
    content: '';
    position: absolute;
    width: 5px;
    height: 100%;
    background: var(--secondary-color);
    left: 0%;
    top: 0%;
    transform: translate(0%, 0%);

  }
}

::v-deep .el-button--primary {
  // width: 100%;
  // min-width: 9.5rem;
  background-color: var(--highlight-color, #5b7b97);
  color: white;
  border-color: var(--highlight-color, #5b7b97);
  border-radius: 6px;
  font-weight: 600;

  &:hover {
    background-color: var(--highlight-color, #5b7b97);
    border-color: var(--highlight-color, #5b7b97);
    opacity: 0.9;
  }

  &:disabled {
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    color: #999999;
  }
}

::v-deep .el-button--warning {
  width: 100%;
  min-width: 8.5rem;
  background-color: var(--highlight-color, #7a8fa6);
  color: white;
  border-color: var(--highlight-color, #7a8fa6);
  border-radius: 6px;
  font-weight: 600;

  &:hover {
    background-color: var(--highlight-color, #7a8fa6);
    border-color: var(--highlight-color, #7a8fa6);
    opacity: 0.9;
  }
}

::v-deep .el-button--info {
  width: 100%;
  min-width: 8.5rem;
  background-color: #e0e0e0;
  color: #666666;
  border-color: #e0e0e0;
  border-radius: 6px;
  font-weight: 600;

  &:hover {
    background-color: #d0d0d0;
    border-color: #d0d0d0;
  }
}

::v-deep .el-button--success {
  width: 100%;
  min-width: 8.5rem;
  background-color: #e8f0f5;
  color: #5b7b97;
  border-color: #e8f0f5;
  border-radius: 6px;
  font-weight: 600;

  &:hover {
    background-color: #dce8f0;
    border-color: #dce8f0;
  }
}

::v-deep .el-tag {
  line-height: 20px;
  height: 20px;
  font-size: 12px;
  margin-right: 0.25rem;
  border-color: transparent;
  border-radius: 6px;
}

.registration-card-container {
  padding: 32px 24px;
  min-height: 380px;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12), 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.12);
  }

  .info-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-bottom: 24px;

    .info-description {
      .img-container {
        margin-bottom: 24px;
        display: flex;
        justify-content: center;

        .el-avatar {
          width: 80px;
          height: 80px;
          border-radius: 16px;
          background: #F5F5F7;
          border: 2px solid rgba(0, 0, 0, 0.04);
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);

          img {
            width: 76px;
            height: 76px;
            border-radius: 14px;
            object-fit: cover;
          }
        }
      }

      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      text-align: center;

      .title {
        font-weight: 600;
        font-size: 20px;
        line-height: 26px;
        color: #1A1A1A;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: -0.3px;
        margin-bottom: 8px;
        min-height: 52px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .orgtree-level {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #6B7280;
        letter-spacing: -0.2px;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
      }

      .duration {
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        color: #9CA3AF;
        letter-spacing: -0.1px;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        padding: 6px 12px;
        background: #F9FAFB;
        border-radius: 6px;
        border: 1px solid #E5E7EB;
      }

      .register-button {
        display: flex;
        width: 100%;
        margin-top: auto;

        .el-button {
          width: 100%;
          height: 48px;
          font-weight: 600;
          font-size: 16px;
          border-radius: 8px;
          transition: all 0.2s ease;

          &.el-button--primary {
            background: var(--highlight-color);
            border: none;

            &:hover {
              transform: translateY(-1px);
              box-shadow: 0px 4px 12px rgba(102, 126, 234, 0.4);
            }
          }

          &.closed-register {
            background: #F3F4F6;
            color: #9CA3AF;
            border: 1px solid #E5E7EB;
          }
        }
      }
    }
  }

  .triangle-indicator {
    position: absolute;
    top: 112.2%;
    left: 50%;
    height: 2rem;
    width: 2rem;
    transform: translate(-50%, -50%) rotate(45deg);
    background: #FFFFFF;
    border-left: 0.5px solid rgba(0, 0, 0, 0.2);
    border-top: 0.5px solid rgba(0, 0, 0, 0.2);

  }
}

.products-container {
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  padding: 32px 24px;
  margin-top: 24px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.1), 0px 2px 6px rgba(0, 0, 0, 0.06);
  }

  .label-headers {
    display: flex;
    // grid-template-columns: 8fr 2fr;
    gap: 10px;
    align-items: flex-end !important;
    justify-items: center;
    margin-bottom: 0.5rem;
    // padding: 0 1rem;

    .label-header {
      font-weight: 600;
      color: #9f9f9f;
      font-size: 16px;
      line-height: 25px;
      opacity: 0.8;
      margin-right: 10px;
      grid-row-start: 1;
    }

    .description-expand {
      display: flex;
      flex-direction: column;
      width: 100%;

      .description {
        position: relative; // Added to position the gradient overlay
        flex-basis: 80%;
        font-weight: 300;
        color: #535353;
        font-size: 12px;
        line-height: 20px;
        opacity: 0.7;
        margin-right: 10px;
        grid-row-start: 1;
        align-items: flex-start !important;
        justify-items: flex-start !important;
        font-family: 'BrownStd-Light' !important;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        // -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        // max-height: 100px;
        transition: max-height 0.25s ease;

        // change font family of p to BrownStd-Light
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 25px;
          background: linear-gradient(to top, white, rgba(255, 255, 255, 0));
          pointer-events: none;
        }

        &.no-gradient::after {
          display: none;
        }

        &.expanded {
          max-height: none;
        }
      }

      .expand-icon {
        cursor: pointer;
        color: var(--secondary-color);
        font-size: 14px;
        margin-left: 5px;
        text-align: center;

      }
    }

    .expand-all-button {
      display: flex;
      justify-content: flex-end;
      flex-basis: 20%;
      margin-right: 1rem
    }
  }

  .product-container {
    display: flex;
    flex-direction: column;
    padding: 16px 0;
    position: relative;
    border-bottom: 1px solid #e9ecef;

    &:last-child {
      border-bottom: none;
    }

    &:hover:not(:has(.header)) {
      background-color: #fafbfc;
      transition: background-color 0.2s ease;
    }

    .product-container-main {
      display: grid;
      grid-template-columns: minmax(400px, 1fr) 100px 180px;
      gap: 20px;
      align-items: center;
      padding: 0 20px;

      &.header {
        background-color: #f8f9fa;
        padding: 12px 2rem;
        margin: -12px -20px 12px -20px;
        border-radius: 8px 8px 0 0;

        p {
          color: #6c757d;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          padding: 0;
          margin: 0;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.8px;
        }
      }

      // margin-top: 20px;

      .product-description {
        color: $primary;
        display: grid;
        grid-template-columns: 100px 80px 100px 1fr;
        gap: 15px;
        align-items: center !important;

        .product-displayName {
          // margin-left: 0 10%;
          // display: flex;
          // align-items: center;
          // opacity: 0.6;
          color: #3c3c3c;
          margin: 0;
          width: 16rem;
          font-style: normal;
          // font-weight: 700;
          // font-size: 1.2rem;
          // display:inline-block;
          // line-height: 2.5rem;
          // ellipsis
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .max-lines {
            /* Set a height for the container */
            height: 3.75rem;
            /* 5 lines x 0.75rem line height */
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            line-clamp: 5;
            -webkit-box-orient: vertical;
          }

          .max-lines p {
            margin: 0;
            /* remove any margin that may be applied to the p tag by default */
            line-height: 0.75rem;
            /* set the desired line height */
          }
        }

        .membertype-gender {
          display: grid;
          grid-template-columns: 7fr 3fr;
        }

      }

      .tag {
        // background: rgba(196, 196, 196, 0.2);
        border-radius: 8px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 13px;
        line-height: 28px !important;
        height: 28px;
        padding: 0 12px;
      }

      .dark-color {
        background: rgba(196, 196, 196, 0.25);
        color: #3c3c3c;
      }

      .memberType {
        width: 90px;
        font-size: 12px;
      }

      .gender {
        width: 70px;
        font-size: 12px;
      }

      .product-displayName {
        margin-left: 0 10%;
        display: flex;
        align-items: center;
        // opacity: 0.6;
        font-style: normal;
        font-weight: 500;
        // font-size: 1rem;
        display: inline-block;
        // line-height: 2.5rem;
        // ellipsis
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .product-tags {
        align-items: center;
        display: flex;

        span {
          font-family: $fontBold !important;
          font-weight: 700;
          font-size: 15px;
          line-height: 25px;
          letter-spacing: -0.5px;
          color: #303133;
          opacity: 0.6;
        }

        overflow: hidden;
        word-break: break-word !important;
      }

      .product-register {
        font-size: 14px;
        font-weight: 600;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-button {
          width: 100%;
          min-width: 140px;
          font-weight: 600;
          padding: 8px 16px;
          white-space: nowrap;
        }
        justify-content: flex-end;

        .secondary-type {
          background: var(--secondary-color);
          color: var(--text-color-secondary);

          // color: #000;
          &:hover {
            // hover color to higher contrast
            background: var(--secondary-color);
            opacity: 0.8;
            // color: #000;
          }
        }
      }

      .product-price {
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 1.5;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-radius: 8px;
      }
    }

    .product-tag {
      border-radius: 20px;
      font-weight: 500;
      font-size: 12px;
      line-height: 1.2;
      color: #4B5563;
      background: #F3F4F6;
      border: 1px solid #E5E7EB;
      padding: 6px 12px;
      display: inline-flex;
      align-items: center;
      transition: all 0.2s ease;
      margin: 2px;

      &:hover {
        cursor: pointer;
        background: #E5E7EB;
        border-color: #D1D5DB;
        transform: translateY(-1px);
      }
    }

    .product-container-expand {
      display: flex;
      // gap: 20px;
      // grid-template-columns: 2.9fr 7.1fr;

      margin-top: 20px;

      // .title{
      //   width: 5rem;
      //   text-align: center;
      //   font-size: 1rem;
      // }
      .product-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .tag {
          // background: rgba(196, 196, 196, 0.2);
          border-radius: 50px;
          font-weight: 400;
        }
      }

    }

    .desktop-tag-list {
      margin-left: 18rem;
    }

  }

}

.products-container-mobile {
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  margin-top: 24px;
  transition: all 0.3s ease;

  .label-headers {
    display: flex;
    // grid-template-columns: 8fr 2fr;
    gap: 10px;
    align-items: flex-end !important;
    justify-items: center;
    margin-bottom: 0.5rem;
    // padding: 0 1rem;

    .label-header {
      font-weight: 600;
      color: #9f9f9f;
      font-size: 16px;
      line-height: 25px;
      opacity: 0.8;
      margin-right: 10px;
      grid-row-start: 1;
    }

    .description-expand {
      display: flex;
      flex-direction: column;
      width: 100%;

      .description {
        position: relative; // Added to position the gradient overlay
        flex-basis: 80%;
        font-weight: 300;
        color: #535353;
        font-size: 12px;
        line-height: 20px;
        opacity: 0.7;
        margin-right: 10px;
        grid-row-start: 1;
        align-items: flex-start !important;
        justify-items: flex-start !important;
        font-family: 'BrownStd-Light' !important;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        // -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        max-height: 100px;
        transition: max-height 0.25s ease;

        // change font family of p to BrownStd-Light
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 25px;
          background: linear-gradient(to top, white, rgba(255, 255, 255, 0));
          pointer-events: none;
        }

        &.no-gradient::after {
          display: none;
        }

        &.expanded {
          max-height: none;
        }
      }

      .expand-icon {
        cursor: pointer;
        color: var(--secondary-color);
        font-size: 14px;
        margin-left: 5px;
        text-align: center;

      }
    }

    .expand-all-button {
      display: flex;
      justify-content: flex-end;
      flex-basis: 20%;
      margin-right: 1rem
    }
  }

  .product-container {
    display: flex;
    flex-direction: column;
    padding: 10px;
    // border-top: 0.5px solid rgba(0, 0, 0, 0.2);
    // border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);

    .product-tag {
      border-radius: 10px;
      // text-align: center;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      font-weight: 400;
      font-size: 11px;
      font-family: 'BrownStd-Light';
      line-height: 25px !important;
      color: #303133;
      /* line-height: 25px !important; */
      height: 25px;
      color: #606060;
      padding: 0.5rem;
      // background: #f9f9f9;
      display: inline-flex;
      align-items: center;

      // .tag{
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }

      // }
    }

    .product-container-main-mobile {
      .product-description {
        display: flex;
        // justify-content: space-between;
        margin: 11px 0 0 0;
        padding: 0 1rem;

        .tag {
          // background: rgba(196, 196, 196, 0.2);
          border-radius: 50px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 400;
          font-size: 1.1rem;
          line-height: 2rem;
        }

        .dark-color {
          background: #c4c4c4;
        }

        .member-type {
          flex-basis: 50%;
        }

        .gender {
          flex-basis: 30%;
        }

        .age {
          flex-basis: 20%;
        }

        .product-displayName {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          opacity: 0.6;
          font-style: normal;
          font-weight: 500;
          font-size: 1rem;
          line-height: 1.8rem;

          // limit line to 5
          .max-lines {
            /* Set a height for the container */
            max-height: 9rem;
            /* 5 lines x 0.75rem line height */
            overflow: hidden;
            font-style: normal;
            font-weight: 700;
            font-size: 1.2rem;
            line-height: 1.8rem;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            line-clamp: 5;
            -webkit-box-orient: vertical;
          }

          .max-lines p {
            margin: 0;
            /* remove any margin that may be applied to the p tag by default */
            line-height: 1.8rem;
            /* set the desired line height */
          }

        }

        .product-tags {
          align-items: center;
          display: flex;

          span {
            font-family: $fontBold !important;
            font-weight: 700;
            font-size: 15px;
            line-height: 25px;
            letter-spacing: -0.5px;
            color: #303133;
            opacity: 0.6;
          }

          overflow: hidden;
          word-break: break-word !important;
        }

        .product-price {
          font-style: normal;
          font-weight: 400;
          font-size: 1rem;
          line-height: 1.8rem;
          display: flex;
          align-items: center;
          letter-spacing: -0.5px;
          color: #303133;
        }
      }

      .grid-style {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
      }

      .product-register {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;

        // justify-content: flex-end;
        // flex-direction: column;
        .secondary-type-button {
          background: var(--secondary-color);
          color: #000;

          &:hover {
            // hover color to higher contrast
            background: var(--secondary-color);
            opacity: 0.8;
            color: #000;
          }
        }

        .primary-type-button {
          margin: 0;
          // display: flex;
          // border-radius: 50px;
          // text-align: center;
          // align-items: center;
          // justify-content: center;
          // margin-bottom: 10px;
        }
      }
    }

    .product-container-expand {
      display: flex;
      // gap: 20px;
      // grid-template-columns: 2.9fr 7.1fr;

      margin-top: 20px;

      // .title{
      //   width: 5rem;
      //   text-align: center;
      //   font-size: 1rem;
      // }
      .product-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .tag {
          // background: rgba(196, 196, 196, 0.2);
          border-radius: 50px;
          font-weight: 400;
        }
      }

    }

    .desktop-tag-list {
      margin-left: 18rem;
    }

  }

}

.search-bar-team {
  border: 1px solid #aaaaaa;
  border-radius: 3px;
  // width: 100%;
  display: flex !important;
  justify-content: flex-start;
  text-align: start;
  width: 100%;
  margin-top: 1rem
}

.team-list {

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // justify-content: center;
  margin-top: 2rem;
  width: 100%;
  height: 30rem;
  overflow-y: auto;
  padding: 10px;
  border-top: 1px solid #c4c4c4;
  border-bottom: 1px solid #c4c4c4;
  .team-row-card {
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          width: 100%;
          border-radius: 8px;
          padding: 12px 16px;
          margin-bottom: 8px;
          border: 1px solid #e5e7eb;
          background: #ffffff;
          transition: all 0.2s ease;

          &:hover:not(.team-row-disabled) {
            background: #f8fafc;
            border-color: #d1d5db;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          }

          &.team-row-disabled {
            background: #f9fafb;
            border-color: #e5e7eb;
            opacity: 0.7;
          }

          .team-info {
            flex: 1 1 auto;
            margin-right: 16px;
            min-width: 0; // Allows text to wrap/truncate properly

            .team-name {
              font-weight: 500;
              color: #1f2937;
              font-size: 14px;
              margin-bottom: 4px;
              line-height: 1.4;
              display: block; // Changed from flex to block for simpler layout

              .status-text {
                font-size: 12px;
                font-weight: 400;
                color: #6b7280;
              }
            }

            .team-contact {
              font-size: 12px;
              color: #6b7280;
              font-weight: 400;
              line-height: 1.3;
            }
          }

          .team-action {
            flex: 0 0 auto;
            margin-left: auto;

            .register-btn {
              min-width: 60px;
              font-size: 12px;
              padding: 6px 12px;
              border-radius: 6px;
              font-weight: 500;

              &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
              }
            }
          }

          &.team-row-disabled {
            .team-info .team-name {
              color: #9ca3af;
            }

            .team-info .team-contact {
              color: #d1d5db;
            }
          }
        }

        .entity-option {
          width: 100%;
          justify-content: flex-start;
          border-radius: 8px;
          font-size: 12px;
          text-align: left;
          padding: 8px 12px;
          margin-left: 0 !important;
          height: auto;
          min-height: 36px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          &:hover {
            background: var(--secondary-color);
            color: white;
          }
        }

  // padding: 1rem;
  .team {
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    padding: 1rem;
    border-bottom: 1px solid #c4c4c4;

    .membership-type {
      background: rgba(196, 196, 196, 0.2);
      border-radius: 50px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 1.1rem;
      line-height: 2rem;
      width: 10rem
    }

    .register-button {
      width: 100%;
    }

    .membership-name {
      display: flex;
      align-items: center;
      padding-left: 1rem;
    }
  }
}

::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  th {
    background: #f6f8fa !important;
    padding-right: 1em;
    text-align: left;
  }

  td {
    background-color: white !important;
    padding-top: 2em;
    text-align: left;
  }
}

// Remove backdrop filter effects
::v-deep .el-dialog__wrapper {
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  z-index: 3000 !important;
}

// Ensure proper modal overlay
::v-deep .v-modal {
  background-color: rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  z-index: 2999 !important;
}

// Force dialog to appear above drawer
::v-deep .el-dialog {
  z-index: 3001 !important;
}

// Global override for all dialogs when inside drawer
body.el-popup-parent--hidden {
  .el-dialog__wrapper {
    z-index: 3000 !important;
  }

  .el-dialog {
    z-index: 3001 !important;
  }

  .v-modal {
    z-index: 2999 !important;
  }
}

// Team Selection Dialog Styling
.team-selection-dialog {
  .el-dialog {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    width: 700px !important;
    max-width: 95vw !important;
  }

  // Mobile responsiveness
  @media (max-width: 768px) {
    .el-dialog {
      width: 95vw !important;
      margin: 20px auto !important;
      border-radius: 12px;
    }
  }

  .el-dialog__header {
    background: #ffffff;
    border-bottom: 1px solid #e9ecef;
    padding: 16px 20px;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
    }

    @media (max-width: 768px) {
      padding: 14px 16px;

      .el-dialog__title {
        font-size: 16px;
      }
    }

    .el-dialog__headerbtn {
      top: 18px;
      right: 20px;

      .el-dialog__close {
        color: #999999;
        font-size: 16px;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        transition: all 0.2s ease;

        &:hover {
          color: #333333;
          background: #f5f5f5;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 0;
    overflow: hidden;
  }

  .el-dialog__footer {
    background: #ffffff;
    border-top: 1px solid #e9ecef;
    padding: 14px 20px;
    text-align: right;
    gap: 12px;

    .el-button {
      border-radius: 6px;
      font-size: 14px;

      &.register-button {
        background: var(--secondary-color, #5145cd);
        border-color: var(--secondary-color, #5145cd);
        color: white;

        &:hover {
          background: #4338ca;
          border-color: #4338ca;
        }
      }
    }

    @media (max-width: 768px) {
      padding: 12px 16px;
      gap: 8px;

      .el-button {
        padding: 8px 16px;
        font-size: 13px;
      }
    }
  }
}

.team-dialog-content {
  display: flex;
  flex-direction: column;
  height: 450px;
  width: 100%;

  // Mobile responsiveness
  @media (max-width: 768px) {
    height: 70vh;
    max-height: 500px;
  }

  .dialog-description {
    padding: 16px 20px 12px 20px;
    border-bottom: 1px solid #f0f0f0;

    p {
      margin: 0;
      font-size: 14px;
      color: #555555;
      line-height: 1.5;
      word-break: break-word;
    }

    @media (max-width: 768px) {
      padding: 12px 16px 10px 16px;

      p {
        font-size: 13px;
      }
    }
  }

  .search-section {
    padding: 16px 20px;
    // background: #fafafa;

    .search-input {
      width: 100%;

      .el-input__inner {
        border-radius: 6px;
        border: 1px solid #ddd;
        padding: 0 16px;
        font-size: 14px;
        height: 40px;

        &:focus {
          border-color: var(--secondary-color);
          box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.1);
        }
      }

      .el-input-group__append {
        .el-button {
          border-radius: 0 6px 6px 0;
          background: var(--secondary-color);
          border-color: var(--secondary-color);
          color: white;
          height: 40px;

          &:hover {
            background: #4338ca;
          }
        }
      }

      // Fix suffix button icon size
      .el-input__suffix {
        .el-button {
          height: 100%;
          padding: 0 12px;
          border: none;
          background: transparent;

          .el-icon-search {
            font-size: 16px;
          }
        }
      }
    }

    @media (max-width: 768px) {
      padding: 12px 16px;

      .search-input {
        .el-input__inner {
          height: 36px;
          font-size: 13px;
          padding: 0 12px;
        }

        .el-input-group__append {
          .el-button {
            height: 36px;
            padding: 0 12px;
          }
        }

        .el-input__suffix {
          .el-button {
            .el-icon-search {
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  .help-text {
    padding: 12px 20px;

    p {
      margin: 0;
      font-size: 13px;
      color: #888888;
      text-align: center;
      padding: 10px;
      background: #f8f9fa;
      border-radius: 6px;
      border: 1px solid #e9ecef;
      word-break: break-word;
    }

    @media (max-width: 768px) {
      padding: 10px 16px;

      p {
        font-size: 12px;
        padding: 8px;
      }
    }
  }

  .teams-section {
    flex: 1;
    min-height: 0;
    padding: 0 20px 20px 20px;

    @media (max-width: 768px) {
      padding: 0 16px 16px 16px;
    }

    .teams-list {
      height: 100%;
      overflow-y: auto;
      border: 1px solid #e9ecef;
      border-radius: 6px;
      background: #ffffff;

      .team-card {
        border-bottom: 1px solid #f0f0f0;
        padding: 12px 16px;
        margin-bottom: 8px;
        transition: all 0.2s ease;
        cursor: pointer;

        &:last-child {
          border-bottom: none;
          margin-bottom: 0;
        }

        &:hover {
          background: #f8f9fa;
        }

        &.my-team {
          background: #f0f9ff;
          border-left: 3px solid #3b82f6;

          &:hover {
            background: #e0f2fe;
          }
        }

        @media (max-width: 768px) {
          padding: 10px 12px;
          margin-bottom: 6px;
        }

        .team-main-info {
          .team-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 8px;

            .team-name {
              flex: 1;
              font-size: 15px;
              font-weight: 600;
              color: #333333;
              line-height: 1.4;
              margin-right: 12px;
              display: flex;
              align-items: center;
              gap: 8px;

              .my-team-badge {
                background: #dcfce7;
                color: #16a34a;
                border: 1px solid #bbf7d0;
                font-size: 11px;
                // padding: 2px 6px;
                // border-radius: 12px;

                i {
                  margin-right: 2px;
                }
              }

              @media (max-width: 768px) {
                font-size: 14px;
                margin-right: 8px;
                gap: 6px;

                .my-team-badge {
                  font-size: 10px;
                  padding: 1px 4px;
                }
              }
            }

            .team-action {
              .register-btn {
                padding: 6px 16px;
                font-size: 13px;
                border-radius: 4px;
                font-weight: 500;

                &[type="primary"] {
                  background: var(--secondary-color);
                  border-color: var(--secondary-color);

                  &:hover {
                    background: #4338ca;
                    border-color: #4338ca;
                  }
                }

                &[type="info"] {
                  background: #e5e7eb;
                  color: #6b7280;
                  border-color: #e5e7eb;
                  cursor: not-allowed;
                }

                @media (max-width: 768px) {
                  padding: 5px 12px;
                  font-size: 12px;
                }
              }
            }
          }

          .team-details {
            .team-org {
              display: flex;
              align-items: center;
              gap: 6px;
              font-size: 13px;
              color: #666666;
              margin-bottom: 6px;

              i {
                color: #999999;
              }

              @media (max-width: 768px) {
                font-size: 12px;
                gap: 4px;
                margin-bottom: 4px;
              }
            }

            .team-meta {
              display: flex;
              gap: 16px;
              font-size: 12px;
              color: #888888;

              span {
                display: flex;
                align-items: center;
                gap: 4px;

                i {
                  color: #aaa;
                  font-size: 11px;
                }

                &.created-by {
                  .my-team-badge {
                    background: #dcfce7;
                    color: #16a34a;
                    border: 1px solid #bbf7d0;
                    font-size: 10px;
                    margin-left: 4px;

                    i {
                      margin-right: 2px;
                      color: #16a34a;
                      font-size: 10px;
                    }
                  }
                }
              }

              @media (max-width: 768px) {
                gap: 12px;
                font-size: 11px;

                span {
                  gap: 3px;

                  i {
                    font-size: 10px;
                  }

                  &.created-by {
                    .my-team-badge {
                      font-size: 9px;
                      margin-left: 3px;

                      i {
                        font-size: 9px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      .empty-state {
        text-align: center;
        padding: 40px 20px;
        color: #999999;

        i {
          font-size: 32px;
          margin-bottom: 12px;
          display: block;
        }

        p {
          margin: 0;
          font-size: 14px;
        }
      }
    }
  }
}

.team-selector {
  width: 100%;
  padding: 0;

  .team-selector-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }
}

::v-deep .el-collapse-item__content {
  padding: 0 0 1rem 0;
}

::v-deep .el-card__body {
  padding: 0;
  // show box shadow
  // box-shadow: 0px 3px 6px rgba(233, 233, 233, 0.5) !important
}

::v-deep .el-card.is-always-shadow {
  box-shadow: rgba(50, 50, 105, 0.1) 0px 2px 3px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
}

.custom-input-pasword {
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 4px;
}

.dialog-footer {
  display: flex;
  gap: 12px;

  .confirm-button {
    background: var(--secondary-color);
    color: var(--text-color-secondary);
  }

  .el-button {
    margin: 0 !important;
  }
}

.disabled-row {
  color: #ccc;
  pointer-events: none;
}

.family-ms-dialog {
  flex-direction: column;
  max-width: 80%;
}

.family-ms-content {
  max-height: 60vh;
  overflow-y: auto;
}

.family-ms-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

@media (max-width: 767px) {
  .mobile-family-ms-item {
    background-color: #f5f7fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;
  }

  .mobile-family-ms-field {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
  }

  .mobile-label {
    font-weight: bold;
    color: #606266;
    margin-right: 10px;
    min-width: 100px;
    display: flex;
    align-items: center;
  }

  .mobile-label i {
    margin-right: 5px;
    font-size: 16px;
  }

  .mobile-tag {
    margin-right: 8px;
    margin-bottom: 8px;
  }

  .mobile-age-range {
    font-size: 14px;
    color: #303133;
  }

  .mobile-member-select {
    width: 100% !important;
    margin-top: 5px;
  }

  .el-select {
    width: 100%;
  }

}

.age-range-text {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.d-flex {
  &.gap-1 {
    gap: 0.5rem;
  }

  i.el-icon-s-data {
    font-size: 16px;
    color: #606266;
  }
}

/* Enhanced Mobile UX and Visual Feedback */
@media (max-width: 1024px) {
  .products-container-mobile {
    background: #f8f9fa;
    border-radius: 12px;
    border: 1px solid #e9ecef;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    .product-container {
      transition: all 0.3s ease;
      border-radius: 8px;
      overflow: hidden;
      margin: 8px 0;

      /* Add subtle hover effect for touch feedback */
      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-1px);
      }

      /* Add click feedback */
      &:active {
        transform: translateY(0) scale(0.98);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
      }

      .el-card {
        transition: all 0.3s ease;
        border: 1px solid #e9ecef;
        border-radius: 12px;
        background: #ffffff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

        &:hover {
          border-color: var(--secondary-color);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        }
      }
    }

    /* Mobile Product Actions */
    .mobile-product-actions {
      border-top: 1px solid #f0f0f0;
      padding-top: 12px;
      background: linear-gradient(to bottom, transparent, rgba(248, 249, 250, 0.5));

      .product-status-info {
        .status-label {
          font-size: 12px;
          font-weight: 500;
          padding: 4px 8px;
          border-radius: 16px;
          display: inline-flex;
          align-items: center;

          &.status-available {
            background: #e7f5e7;
            color: #52c41a;
          }

          &.status-required {
            background: #fff7e6;
            color: #fa8c16;
          }

          &.status-closed {
            background: #f6f6f6;
            color: #8c8c8c;
          }

          &.status-ineligible {
            background: #fff1f0;
            color: #ff4d4f;
          }

          &.status-registered {
            background: #e6f7ff;
            color: #1890ff;
          }

          &.status-full {
            background: #fff0f6;
            color: #c41d7f;
          }

          &.status-pay-now {
            background: #f6ffed;
            color: #389e0d;
          }
          &.status-renew-now {
            background: #e6f7ff;
            color: #1890ff;
          }
        }
      }

    }

    /* Team and Entity Selection Popovers */
    .team-selection-mobile,
    .entity-selection-mobile {
      h4 {
        margin: 0 0 12px 0;
        font-size: 14px;
        font-weight: 600;
        color: #262626;
      }

      .team-list,
      .entity-list {

        max-height: 200px;
        overflow-y: auto;

        .team-row-card {
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          width: 100%;
          border-radius: 8px;
          padding: 12px 16px;
          margin-bottom: 8px;
          border: 1px solid #e5e7eb;
          background: #ffffff;
          transition: all 0.2s ease;

          &:hover:not(.team-row-disabled) {
            background: #f8fafc;
            border-color: #d1d5db;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          }

          &.team-row-disabled {
            background: #f9fafb;
            border-color: #e5e7eb;
            opacity: 0.7;
          }

          .team-info {
            flex: 1 1 auto;
            margin-right: 16px;
            min-width: 0; // Allows text to wrap/truncate properly

            .team-name {
              font-weight: 500;
              color: #1f2937;
              font-size: 14px;
              margin-bottom: 4px;
              line-height: 1.4;
              display: block; // Changed from flex to block for simpler layout

              .status-text {
                font-size: 12px;
                font-weight: 400;
                color: #6b7280;
              }
            }

            .team-contact {
              font-size: 12px;
              color: #6b7280;
              font-weight: 400;
              line-height: 1.3;
            }
          }

          .team-action {
            flex: 0 0 auto;
            margin-left: auto;

            .register-btn {
              min-width: 60px;
              font-size: 12px;
              padding: 6px 12px;
              border-radius: 6px;
              font-weight: 500;

              &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
              }
            }
          }

          &.team-row-disabled {
            .team-info .team-name {
              color: #9ca3af;
            }

            .team-info .team-contact {
              color: #d1d5db;
            }
          }
        }

        .entity-option {
          width: 100%;
          justify-content: flex-start;
          border-radius: 8px;
          font-size: 12px;
          text-align: left;
          padding: 8px 12px;
          margin-left: 0 !important;
          height: auto;
          min-height: 36px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          &:hover {
            background: var(--secondary-color);
            color: white;
          }
        }
      }
    }
  }

  /* Team selection popover styling */
  ::v-deep .team-selection-popover {
    padding: 0 !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
    max-width: 320px !important;
    max-height: 400px !important;
    overflow: hidden !important;
    z-index: 9999 !important;

    .team-selection-mobile {
      padding: 16px;

      h4 {
        margin: 0 0 12px 0;
        font-size: 14px;
        font-weight: 600;
        color: #262626;
      }

      .team-search {
        margin-bottom: 12px;
      }

      .team-list {
        max-height: 240px;
        overflow-y: auto;
      }
    }
  }

  /* Ensure popover appears above drawer on all screen sizes */
  ::v-deep .el-popper.team-selection-popover {
    z-index: 9999 !important;
  }

  /* Make product tags more interactive */
  .product-tag {
    transition: all 0.2s ease;
    border-radius: 16px;
    padding: 4px 8px;
    background: rgba(var(--secondary-color-rgb), 0.1);
    border: 1px solid rgba(var(--secondary-color-rgb), 0.2);

    &:hover {
      background: rgba(var(--secondary-color-rgb), 0.2);
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    &:active {
      transform: translateY(0);
    }
  }

  /* Enhanced button styling for mobile */
  .el-button {
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg,
          transparent,
          rgba(255, 255, 255, 0.3),
          transparent);
      transition: left 0.5s;
    }

    &:hover::before {
      left: 100%;
    }

    &:active {
      transform: scale(0.95);
    }
  }
}

@media (max-width: 767px) {

  /* Enhanced touch targets for phone screens */
  .products-container-mobile {
    .product-container {
      margin-bottom: 16px;
      padding: 8px;

      .el-card {
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

        .el-card__body {
          padding: 16px;
        }
      }
    }
  }

  /* Make tags more touch-friendly */
  .el-tag {
    font-size: 14px;
    border-radius: 8px;
    padding: 0 12px;
    margin: 2px;
  }

  /* Improved visual hierarchy */
  .product-description {
    span {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.4;
      color: #303133;
    }
  }

  /* Add loading states and better feedback */
  .product-container:active {
    .el-card {
      box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }

  /* Better price display */
  .f-bold {
    color: var(--secondary-color);
    font-size: 18px;
    font-weight: 700;
  }

  /* Enhanced Mobile Product Cards */
  .product-name-section {
    padding: 10px 15px 5px;

    .product-name {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin: 0;
      line-height: 1.4;
    }
  }

  .product-tags-section {
    border-top: 1px solid #f5f5f5;
    background: #fafafa;

    .tags-container {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
    }

    .product-tag {
      background: linear-gradient(135deg, var(--secondary-color), #667eea);
      color: white;
      padding: 4px 10px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  .mobile-product-actions {
    border-top: 1px solid #e9ecef;
    background: #ffffff;

    .action-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
    }

    .status-section {
      flex: 1;

      .status-label {
        display: inline-flex;
        align-items: center;
        padding: 6px 12px;
        border-radius: 16px;
        font-size: 12px;
        font-weight: 600;

        .status-icon {
          margin-right: 6px;
        }

        .status-text {
          line-height: 1;
        }
      }
    }

    .button-section {
      flex-shrink: 0;
    }
  }
}

/* Add ripple effect for better mobile interaction feedback */
@keyframes ripple {
  0% {
    transform: scale(0);
    opacity: 1;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}

.product-container {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(var(--secondary-color-rgb), 0.3);
    transform: translate(-50%, -50%) scale(0);
    pointer-events: none;
  }

  &:active::after {
    animation: ripple 0.6s ease-out;
  }
}

/* Custom Collapsible Sections with Sticky Headers */
.custom-collapse-container {
  // Ensure proper stacking context for sticky headers
  padding-bottom: 2rem;

  @media (max-width: 1024px) {
    position: relative;
    z-index: 1;
    padding-bottom: 3rem;
  }

  .custom-collapse-section {
    border: 0.5px solid rgba(0, 0, 0, 0.2);
    margin-bottom: 8px;
    border-radius: 4px;
    // Remove overflow: hidden which breaks sticky positioning
    // overflow: hidden;

    &:last-child {
      margin-bottom: 2rem;
    }

    .custom-section-header {
      background: #f8f9fa;
      cursor: pointer;
      padding: 14px 16px;
      position: relative;
      transition: all 0.2s ease;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      // Add sticky positioning when sticky-section-header class is present
      &.sticky-section-header {
        position: -webkit-sticky;
        position: sticky;
        top: var(--section-sticky-top, 60px);
        z-index: 997;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        background: #f8f9fa !important;
        transition: all 0.3s ease;

        &.is-sticky {
          margin: 0 !important;
          border-radius: 0 !important;
          top: 0 !important;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        &.is-expanded {
          background: var(--secondary-color) !important;
        }
      }

      // Simple accent line
      &::before {
        content: '';
        position: absolute;
        width: 4px;
        height: 100%;
        background: var(--secondary-color);
        left: 0;
        top: 0;
      }

      &:hover {
        background: #e9ecef;
      }

      &.is-expanded {
        background: var(--secondary-color);
        color: white;

        .overview-grid p {
          color: white;
        }

        i {
          color: white;
        }
      }

      .overview-grid {
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
          margin: 0;
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          transition: color 0.2s ease;
        }

        i {
          font-size: 16px;
          transition: transform 0.2s ease;
        }
      }

      // Add sticky positioning for mobile - each header sticks below the event header
      @media (max-width: 1024px) {
        position: sticky;
        top: 1rem; // Dynamic positioning based on event header
        z-index: 997; // Below event sticky header (z-index: 2005)
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        background: $secondaryLight;

        &.is-expanded {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          background: var(--secondary-color);
        }

        // Ensure proper stacking when multiple headers are sticky
        &:not(:first-child) {
          margin-top: -1px; // Prevent gaps between stacked headers
        }
      }
    }

    .custom-section-content {
      background: white;
      transition: all 0.3s ease;

      &.is-collapsed {
        max-height: 0;
        overflow: hidden;
        padding: 0;
      }

      &.is-expanded {
        max-height: none;
        overflow: visible;
        padding: 0 0 2rem 0;
      }

      // Smooth animation for content
      .product-container {
        border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);

        &:last-child {
          border-bottom: none;
        }
      }

      /* Ultra-Modern Product Card Styles - see below for full implementation */
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1),
      0 1px 2px rgba(0, 0, 0, 0.06);
      border: 1px solid #e5e7eb;
      padding: 20px;
      transition: all 0.2s ease;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06);
        transform: translateY(-1px);
        border-color: #d1d5db;
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 16px;

        .product-info {
          flex: 1;
          margin-right: 16px;

          .product-title {
            font-size: 18px;
            font-weight: 600;
            color: #111827;
            margin: 0 0 8px 0;
            line-height: 1.3;
            letter-spacing: -0.01em;
          }

          .product-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            margin-top: 8px;

            .tag-item {
              background: #f9fafb;
              color: #374151;
              padding: 4px 8px;
              border-radius: 4px;
              font-size: 12px;
              font-weight: 500;
              border: 1px solid #e5e7eb;

              &.member-type {
                background: #f3f4f6;
                color: #1f2937;
                border-color: #d1d5db;
              }

              &.gender {
                background: #f3f4f6;
                color: #1f2937;
                border-color: #d1d5db;
              }

              &.age {
                background: #f3f4f6;
                color: #1f2937;
                border-color: #d1d5db;
              }
            }
          }
        }

        .price-section {
          text-align: right;
          flex-shrink: 0;

          .price {
            font-size: 20px;
            font-weight: 700;
            color: #111827;
            background: #f9fafb;
            padding: 8px 12px;
            border-radius: 6px;
            border: 1px solid #e5e7eb;
            display: inline-block;
            min-width: 80px;
          }
        }
      }

      .card-hashtags {
        margin-bottom: 16px;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .hashtag {
          color: #4b5563;
          background: #f9fafb;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 11px;
          font-weight: 500;
          cursor: pointer;
          border: 1px solid #e5e7eb;
          transition: all 0.15s ease;

          &:hover {
            background: #f3f4f6;
            color: #374151;
            border-color: #d1d5db;
          }
        }
      }

      .card-actions {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-top: 12px;
        border-top: 1px solid #e5e7eb;

        .status-info {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #6b7280;
          font-size: 13px;
          font-weight: 500;

          .status-icon {
            font-size: 14px;
          }
        }

        .action-buttons {
          display: flex;
          gap: 8px;
        }
      }
    }

    .modern-action-btn {
      min-width: 100px;
      min-height: 36px;
      font-weight: 600;
      border-radius: 8px;
      border: 1px solid transparent;
      font-size: 14px;
      transition: all 0.2s ease;
      position: relative;
      overflow: hidden;

      &.el-button--primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);

        &:hover {
          background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.35);
          transform: translateY(-1px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 6px rgba(59, 130, 246, 0.25);
        }
      }

      &:disabled {
        background: #f1f5f9 !important;
        color: #94a3b8 !important;
        border-color: #e2e8f0 !important;
        box-shadow: none !important;
        transform: none !important;
        cursor: not-allowed;
      }

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      &:active {
        transform: translateY(0);
      }

      &:disabled {
        opacity: 0.6;
        transform: none !important;
        box-shadow: none !important;
      }
    }

    // Clean, professional, minimalist card design
    .clean-product-card {
      background: #ffffff;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 12px;
      transition: all 0.2s ease;

      &:hover {
        border-color: #d1d5db;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
      }

      .card-header {
        margin-bottom: 16px;

        &.no-product-name {
          margin-bottom: 12px;
        }

        .standard-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 16px;
          width: 100%;

          .product-name {
            font-size: 16px;
            font-weight: 600;
            color: #111827;
            margin: 0;
            line-height: 1.4;
            flex: 1;
          }

          .product-price {
            font-size: 16px;
            font-weight: 700;
            color: #007bff;
            padding: 4px 12px;
            border-radius: 6px;
            border: 1px solid #bbf7d0;
            white-space: nowrap;
          }
        }

        .inline-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          width: 100%;

          .inline-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            flex: 1;

            .tag {
              padding: 4px 10px;
              border-radius: 6px;
              font-size: 12px;
              font-weight: 600;
              border: 1px solid;
              transition: all 0.2s ease;
              display: inline-flex;
              align-items: center;

              &.member-type-tag {
                background: #dbeafe;
                color: #1e40af;
                border-color: #bfdbfe;
                cursor: default;

                &:hover {
                  background: #bfdbfe;
                  color: #1d4ed8;
                  transform: none;
                }
              }
            }
          }

          .product-price {
            font-size: 16px;
            font-weight: 700;
            color: #007bff;
            padding: 4px 12px;
            border-radius: 6px;
            border: 1px solid #bbf7d0;
            white-space: nowrap;
            flex-shrink: 0;
          }
        }
      }

      .product-details {
        margin-bottom: 16px;

        .detail-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 6px 0;
          border-bottom: 1px solid #f3f4f6;

          &:last-child {
            border-bottom: none;
          }

          .detail-label {
            font-size: 13px;
            color: #6b7280;
            font-weight: 500;
          }

          .detail-value {
            font-size: 13px;
            color: #374151;
            font-weight: 600;
            text-align: right;
          }
        }
      }

      .product-tags {
        margin-bottom: 16px;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;

        .tag {
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 600;
          border: 1px solid;
          transition: all 0.2s ease;
          display: inline-flex;
          align-items: center;

          // Default tag styling (for hashtags)
          background: #f1f5f9;
          color: #475569;
          border-color: #e2e8f0;
          cursor: pointer;

          &:hover {
            background: #e2e8f0;
            color: #334155;
            border-color: #cbd5e1;
            transform: translateY(-1px);
          }

          &:active {
            transform: translateY(0);
          }

          // Member Type Tag
          &.member-type-tag {
            background: #dbeafe;
            color: #1e40af;
            border-color: #bfdbfe;
            cursor: default;

            &:hover {
              background: #bfdbfe;
              color: #1d4ed8;
              transform: none;
            }
          }

          // Gender Tag
          &.gender-tag {
            background: #fce7f3;
            color: #be185d;
            border-color: #f9a8d4;
            cursor: default;

            &:hover {
              background: #f9a8d4;
              color: #a21caf;
              transform: none;
            }
          }

          // Age Tag
          &.age-tag {
            background: #ecfdf5;
            color: #059669;
            border-color: #bbf7d0;
            cursor: default;

            &:hover {
              background: #bbf7d0;
              color: #047857;
              transform: none;
            }
          }

          // Hashtag (clickable)
          &.hashtag {
            background: #f1f5f9;
            color: #475569;
            border-color: #e2e8f0;
            cursor: pointer;

            &:hover {
              background: #e2e8f0;
              color: #334155;
              border-color: #cbd5e1;
              transform: translateY(-1px);
            }
          }
        }

        .more-tags {
          color: #64748b;
          font-size: 12px;
          font-weight: 500;
          font-style: italic;
        }
      }

      .hashtags-only {
        margin-bottom: 16px;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;

        .tag {
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 600;
          border: 1px solid;
          transition: all 0.2s ease;
          display: inline-flex;
          align-items: center;
          background: #f1f5f9;
          color: #475569;
          border-color: #e2e8f0;
          cursor: pointer;

          &:hover {
            background: #e2e8f0;
            color: #334155;
            border-color: #cbd5e1;
            transform: translateY(-1px);
          }

          &:active {
            transform: translateY(0);
          }
        }

        .more-tags {
          color: #64748b;
          font-size: 12px;
          font-weight: 500;
          font-style: italic;
        }
      }

      .card-action {
        .action-button {
          width: 100%;
          height: 40px;
          font-weight: 600;
          border-radius: 6px;
          font-size: 14px;
          transition: all 0.15s ease;

          &.el-button--primary {
            background-color: var(--highlight-color);
            border-color: var(--highlight-color);

            &:hover {
              background-color: var(--highlight-color);
              border-color: var(--highlight-color);
            }
          }

          &.el-button--warning {
            background-color: #f59e0b;
            border-color: #f59e0b;
            color: white;

            &:hover {
              background-color: #d97706;
              border-color: #d97706;
            }
          }

          &.el-button--success {
            background-color: #10b981;
            border-color: #10b981;

            &:hover {
              background-color: #059669;
              border-color: #059669;
            }
          }

          &:disabled {
            background-color: #f9fafb !important;
            border-color: #e5e7eb !important;
            color: #9ca3af !important;
            cursor: not-allowed;
          }
        }
      }
    }
  }
}

// Team selection modal styling with proper backdrop
.el-dialog__wrapper {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  z-index: 2000 !important;

  .el-dialog {
    background: white !important;
    border-radius: 8px !important;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;

    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #e5e7eb;
      background: white;
      border-radius: 8px 8px 0 0;

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #111827;
      }

      .el-dialog__headerbtn {
        .el-dialog__close {
          color: #6b7280;
          font-size: 18px;

          &:hover {
            color: #374151;
          }
        }
      }
    }

    .el-dialog__body {
      padding: 20px;
      background: white;
      max-height: 60vh;
      overflow-y: auto;

      .search-bar-team {
        margin-bottom: 16px;

        .el-input {
          .el-input__inner {
            border-radius: 6px;
            border: 1px solid #d1d5db;

            &:focus {
              border-color: #3b82f6;
              box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
            }
          }
        }
      }

      .el-table {
        border-radius: 6px;
        overflow: hidden;

        .el-table__header {
          th {
            background-color: #f9fafb;
            color: #374151;
            font-weight: 600;
          }
        }

        .el-table__row {
          &:hover {
            background-color: #f9fafb;
          }
        }
      }

      .team-selector {
        .el-card {
          border: 1px solid #e5e7eb;
          border-radius: 6px;

          &:hover {
            border-color: #d1d5db;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }

    .el-dialog__footer {
      padding: 10px 20px 20px;
      border-top: 1px solid #e5e7eb;
      background: white;
      border-radius: 0 0 8px 8px;

      .el-button {
        border-radius: 6px;
        font-weight: 600;
      }
    }
  }
}

// Ensure modal backdrop covers everything properly
.v-modal {
  background-color: rgba(0, 0, 0, 0.5) !important;
  z-index: 1999 !important;
}

// Team selection popover styling
.team-selection-popover {
  padding: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  border: 1px solid #e5e7eb !important;

  .team-popover-content {
    .popover-header {
      padding: 16px 16px 12px;
      border-bottom: 1px solid #f3f4f6;
      background: #fafafa;
      border-radius: 8px 8px 0 0;

      h4 {
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        color: #374151;
      }
    }

    .search-section {
      padding: 12px 16px;
      border-bottom: 1px solid #f3f4f6;

      .el-input {
        .el-input__inner {
          border-radius: 6px;
          border: 1px solid #d1d5db;
          font-size: 13px;

          &:focus {
            border-color: #3b82f6;
            box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
          }
        }
      }
    }

    .teams-list {
      max-height: 240px;
      overflow-y: auto;

      .team-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        cursor: pointer;
        transition: background-color 0.15s ease;
        border-bottom: 1px solid #f9fafb;

        &:hover {
          background-color: #f9fafb;
        }

        &:last-child {
          border-bottom: none;
        }

        .team-info {
          flex: 1;

          .team-name {
            font-size: 13px;
            font-weight: 600;
            color: #111827;
            margin-bottom: 2px;
          }

          .team-contact {
            font-size: 12px;
            color: #6b7280;
          }
        }

        .select-btn {
          color: #3b82f6;
          font-weight: 600;
          font-size: 12px;
          padding: 4px 8px;

          &:hover {
            background-color: #eff6ff;
            color: #2563eb;
          }
        }
      }

      .show-more {
        padding: 8px 16px;
        text-align: center;
        border-top: 1px solid #f3f4f6;
        background: #fafafa;

        .el-button {
          color: #3b82f6;
          font-size: 12px;
          font-weight: 600;

          &:hover {
            color: #2563eb;
          }
        }
      }

      .no-teams {
        padding: 20px 16px;
        text-align: center;
        color: #6b7280;
        font-size: 13px;

        i {
          margin-right: 6px;
          color: #9ca3af;
        }
      }
    }
  }
}
/* New Mobile Card Design */
.mobile-card-wrapper {
  padding: 0.5rem;
}

.mobile-registration-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  margin-bottom: 1rem;
  transition: all 0.3s ease;

  &:active {
    transform: scale(0.98);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  }

  .mobile-card-header {
    padding: 1rem;
    border-bottom: 1px solid #f0f0f0;

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 1rem;

      .card-title {
        font-size: 1.1rem;
        font-weight: 600;
        line-height: 1.3;
        color: #303133;
        margin: 0;
        flex: 1;
      }

      .price-display {
        font-size: 1.25rem;
        font-weight: 700;
        color: var(--highlight-color, #409eff);
        white-space: nowrap;
      }
    }
  }

  .status-banner {
    margin: 0.75rem 1rem;
    padding: 0.75rem;
    border-radius: 8px;
    background-color: #f5f7fa;
    border: 1px solid #e4e7ed;

    &.status-required {
      background-color: #fef5e7;
      border-color: #f6d178;
      color: #e6a23c;

      .status-label {
        color: #e6a23c;
        font-weight: 600;
      }
    }

    &.status-ineligible {
      background-color: #fef0f0;
      border-color: #fbc4c4;
      color: #f56c6c;

      .status-label {
        color: #f56c6c;
        font-weight: 600;
      }
    }

    &.status-closed {
      background-color: #f4f4f5;
      border-color: #d3d4d6;
      color: #909399;

      .status-label {
        color: #909399;
        font-weight: 600;
      }
    }

    &.status-full {
      background-color: #fdf6ec;
      border-color: #f3d19e;
      color: #e6a23c;

      .status-label {
        color: #e6a23c;
        font-weight: 600;
      }
    }

    &.status-registered {
      background-color: #f0f9ff;
      border-color: #b3d8ff;
      color: #409eff;

      .status-label {
        color: #409eff;
        font-weight: 600;
      }
    }

    .status-content {
      display: flex;
      align-items: center;
      gap: 0.75rem;

      i {
        font-size: 1.25rem;
      }

      .status-text {
        flex: 1;

        .status-label {
          display: block;
          font-size: 0.95rem;
          margin-bottom: 0.25rem;
        }

        .status-description {
          display: block;
          font-size: 0.85rem;
          color: #606266;
          line-height: 1.3;
        }
      }
    }
  }

  .essential-info {
    padding: 0.75rem 1rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;

    .info-item {
      display: flex;
      align-items: center;
      gap: 0.375rem;
      font-size: 0.875rem;
      color: #606266;

      i {
        font-size: 1rem;
        color: #909399;
      }
    }
  }

  .tags-section {
    padding: 0 1rem 0.75rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;

    .product-tag {
      display: inline-block;
      padding: 0.25rem 0.625rem;
      background-color: #ecf5ff;
      color: #409eff;
      border-radius: 4px;
      font-size: 0.75rem;
      cursor: pointer;
      transition: all 0.2s;

      &:active {
        background-color: #409eff;
        color: white;
      }
    }

    .more-tags {
      display: inline-block;
      padding: 0.25rem 0.625rem;
      color: #909399;
      font-size: 0.75rem;
    }
  }

  .card-actions {
    padding: 1rem;
    border-top: 1px solid #f0f0f0;

    .action-btn {
      width: 100%;
      height: 44px;
      font-size: 1rem;
      font-weight: 600;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;

      span {
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;
        line-height: 1.2;
      }

      &.primary-action {
        background: var(--highlight-color, #409eff);
        border-color: var(--highlight-color, #409eff);
        color: white;

        &:active {
          opacity: 0.9;
        }
      }

      &.required-btn {
        background: #fef5e7;
        border-color: #f6d178;
        color: #e6a23c;
        height: auto;
        min-height: 44px;
        padding: 0.75rem 1rem;

        span {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .button-subtitle {
          display: block;
          font-size: 0.75rem;
          font-weight: normal;
          margin-top: 0.125rem;
        }
      }

      &.success-btn {
        background: #f0f9ff;
        border-color: #b3d8ff;
        color: #409eff;
      }

      i {
        font-size: 1.1rem;
      }
    }
  }
}

/* Responsive adjustments for very small screens */
@media (max-width: 375px) {
  .mobile-registration-card {
    .mobile-card-header {
      padding: 0.875rem;

      .header-content {
        .card-title {
          font-size: 1rem;
        }

        .price-display {
          font-size: 1.125rem;
        }
      }
    }

    .essential-info {
      padding: 0.625rem 0.875rem;
      gap: 0.625rem;

      .info-item {
        font-size: 0.8125rem;
      }
    }

    .card-actions {
      padding: 0.875rem;

      .action-btn {
        height: 40px;
        font-size: 0.9375rem;
      }
    }
  }
}

/* Status Display Section */
.status-display-section {
  padding: 1rem;
  border-top: 1px solid #f0f0f0;

  .status-alert {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.875rem;
    border-radius: 8px;
    background-color: #f5f7fa;
    border: 1px solid #e4e7ed;
    text-align: center;

    &.alert-ineligible {
      background-color: #fef0f0;
      border-color: #fbc4c4;
      color: #f56c6c;

      i {
        color: #f56c6c;
      }

      .status-title {
        color: #f56c6c;
      }
    }

    &.alert-closed {
      background-color: #f4f4f5;
      border-color: #d3d4d6;
      color: #909399;

      i {
        color: #909399;
      }

      .status-title {
        color: #909399;
      }
    }

    &.alert-registered {
      background-color: #f0f9ff;
      border-color: #b3d8ff;
      color: #409eff;

      i {
        color: #409eff;
      }

      .status-title {
        color: #409eff;
      }
    }

    i {
      font-size: 1.25rem;
      flex-shrink: 0;
    }

    .status-info {
      flex: 1;

      .status-title {
        display: block;
        font-size: 0.95rem;
        font-weight: 600;
        margin-bottom: 0.25rem;
      }

      .status-desc {
        display: block;
        font-size: 0.85rem;
        color: #606266;
        line-height: 1.3;
      }
    }
  }
}

/* Mobile Section Headers */
.mobile-section-header {
  padding: 1rem;
  background: #f5f7fa;
  border-bottom: 2px solid var(--secondary-color, #e4e7ed);
  margin-bottom: 0.5rem;

  .section-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: #303133;
    margin: 0;
  }

  &.sticky-mobile-header {
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
}

.mobile-section-content {
  padding: 0;
  display: block !important; /* Always visible on mobile */
  height: auto !important;
  opacity: 1 !important;
  //grey background
  background-color: #f5f7fa;
}

/* Hide accordion arrows on mobile */
@media (max-width: 1024px) {
  .custom-collapse-container {
    .custom-section-header {
      display: none;
    }
  }
}

/* Mobile Team Selection Popover */
.mobile-team-selection-popover {
  max-width: calc(100vw - 2rem) !important;

  .team-selection-mobile {
    max-height: 60vh;
    overflow-y: auto;
    padding: 0.5rem;

    h4 {
      margin: 0 0 1rem;
      font-size: 1.125rem;
      font-weight: 600;
      color: #303133;
    }

    .team-search {
      margin-bottom: 1rem;
    }

    .team-list {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .team-row-card {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.75rem;
      background: white;
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      transition: all 0.2s;

      &:not(.team-row-disabled):active {
        background: #f5f7fa;
      }

      &.team-row-disabled {
        opacity: 0.6;
        background: #f5f7fa;
      }

      .team-info {
        flex: 1;
        min-width: 0;

        .team-name {
          font-weight: 600;
          font-size: 0.95rem;
          color: #303133;
          margin-bottom: 0.25rem;

          .status-text {
            font-weight: normal;
            color: #909399;
            font-size: 0.875rem;
          }
        }

        .team-contact {
          font-size: 0.875rem;
          color: #606266;
        }
      }

      .team-action {
        margin-left: 0.75rem;

        .register-btn {
          min-width: 70px;
        }
      }
    }
  }
}

/* Mobile Membership Modal */
.mobile-membership-modal.clean-modal {
  .el-dialog__header {
    padding: 1.5rem 1.5rem 1rem;
    border-bottom: none;
  }

  .el-dialog__title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #303133;
  }

  .el-dialog__body {
    padding: 0 1.5rem 1.5rem;
  }

  .membership-modal-content {
    text-align: center;

    .modal-icon {
      margin-bottom: 1rem;

      i {
        font-size: 3rem;
        color: #e6a23c;
        background: #fef5e7;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }

    .modal-message {
      font-size: 1rem;
      line-height: 1.5;
      color: #606266;
      margin: 0 0 1.5rem;
      max-width: 90%;
      margin-left: auto;
      margin-right: auto;
    }

    .modal-actions {
      display: flex;
      justify-content: center;
      gap: 1rem;

      .el-button {
        min-width: 100px;
        font-weight: 500;

        &--primary {
          background: var(--secondary-color, #409eff);
          border-color: var(--secondary-color, #409eff);
          color: white;
        }
      }
    }
  }

  @media (max-width: 480px) {
    width: 95% !important;

    .el-dialog__header {
      padding: 1rem 1rem 0.75rem;
    }

    .membership-modal-content {
      .modal-actions {
        flex-direction: column-reverse;
        width: 100%;

        .el-button {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
}

/* Password Popover Styles */
::v-deep .password-required-popover {
  .el-popover {
    border-radius: 12px;
    padding: 0;
    border: 1px solid #e2e8f0;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  }
}

.password-popover-content {
  .popover-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    border-bottom: 1px solid #e2e8f0;
    border-radius: 12px 12px 0 0;

    h4 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #2c3e50;
    }

    .close-btn {
      padding: 4px;
      color: #6b7280;
      background: none;
      border: none;

      &:hover {
        background: rgba(107, 114, 128, 0.1);
        border-radius: 4px;
      }
    }
  }

  .popover-body {
    padding: 20px;

    .password-description {
      margin: 0 0 16px 0;
      font-size: 14px;
      line-height: 1.5;
      color: #4b5563;
    }

    .action-section {
      margin-bottom: 16px;

      .request-btn {
        color: #3b82f6;
        padding: 0;
        font-size: 14px;
        text-decoration: underline;

        &:hover {
          color: #1d4ed8;
          background: none;
        }
      }
    }

    .password-form {
      .el-form-item {
        margin-bottom: 12px;

        .el-form-item__label {
          font-size: 14px;
          color: #374151;
          font-weight: 500;
          line-height: 1.5;
          padding-bottom: 4px;
        }

        .custom-input-password {
          .el-input__inner {
            border-radius: 8px;
            border: 1px solid #d1d5db;
            padding: 8px 12px;
            font-size: 14px;

            &:focus {
              border-color: #3b82f6;
              box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
            }
          }
        }
      }

      .error-message {
        margin-top: 8px;

        .el-alert {
          .el-alert__title {
            font-size: 13px;
          }

          .el-alert__icon {
            font-size: 14px;
          }
        }
      }
    }
  }

  .popover-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px 20px;
    background: #f8f9fa;
    border-top: 1px solid #e2e8f0;
    border-radius: 0 0 12px 12px;

    .el-button {
      font-size: 14px;
      padding: 8px 16px;
      border-radius: 6px;

      &.confirm-button {
        background: #3b82f6;
        border-color: #3b82f6;

        &:hover {
          background: #2563eb;
          border-color: #2563eb;
        }
      }
    }
  }
}

/* Family membership popover styles */
.family-ms-popover {
  padding: 20px;

  h3 {
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  .family-ms-content {
    max-height: 400px;
    overflow-y: auto;
    margin-bottom: 15px;

    .el-table {
      border: 1px solid #EBEEF5;
      border-radius: 4px;

      .el-table__header-wrapper {
        background-color: #F5F7FA;
      }

      .member-select {
        width: 100%;
      }
    }
  }

  .family-ms-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 15px;
    border-top: 1px solid #EBEEF5;
  }
}

</style>
